import { jsx as p, jsxs as O, Fragment as sn } from "react/jsx-runtime";
import { useJsApiLoader as wr } from "@react-google-maps/api";
import xn, { useState as _t, useMemo as Ye, memo as yr, useRef as ue, useCallback as xt, useEffect as $e } from "react";
import { OverlayWrapper as Nr } from "../components/organisms/OverlayMap/OverlayWrapper.js";
import { GOOGLE_MAPS_LIBRARIES as br, GOOGLE_MAPS_LOADER_ID as vr, GOOGLE_MAPS_MAP_ID as Cr } from "../config/googleMaps.js";
import Ar from "../components/organisms/ReactMap/index.js";
import { useMapContext as Lr } from "../components/organisms/ReactMap/MapContext.js";
import qn from "lodash/debounce";
import { c as he } from "react/compiler-runtime";
import { FilledInput as Ir, Input as Or, OutlinedInput as Mr, InputAdornment as Sr, IconButton as pe, Box as St, Paper as Qn, Alert as Tr, DialogTitle as Dr, Tooltip as wt, Typography as Sn, Button as Kn, DialogContent as Rr, DialogActions as Fr, Dialog as Er, useTheme as $r, ToggleButton as Xt, MenuItem as mi, ToggleButtonGroup as hi, Menu as kr } from "@mui/material";
import { Warning as Ur, InfoRounded as Vr, Upload as zr, ChevronLeft as Br, ChevronRight as Wr } from "@mui/icons-material";
import { dialogStyles as mn, controlBarStyles as U, mapContainerStyles as gi, iconStyles as Hr } from "../components/organisms/OverlayMap/styles.js";
import { getFileSizeString as _i, createFileChangeHandler as Yr } from "../components/organisms/OverlayMap/utils/uploadUtils.js";
import Gr from "@mui/icons-material/Visibility";
import Xr from "@mui/icons-material/VisibilityOff";
import { theme as de } from "../styles/theme.js";
import "../components/atoms/FormControl/FormControl.js";
import "../components/atoms/FormControlLabel/FormControlLabel.js";
import "./index.esm.js";
import "react-dom/server";
import '../assets/FilterWrapper.css';import '../assets/map.css';import '../assets/Map2.css';/* empty css     */
import { Grid as rt } from "../components/atoms/Grid/Grid.js";
import "../components/atoms/Paper/Paper.js";
import "../components/atoms/Box/Box.js";
import "../components/atoms/Radio/Radio.js";
import "../components/atoms/RadioGroup/RadioGroup.js";
import "../components/atoms/Menu/Menu.js";
import "../components/atoms/MenuItem/MenuItem.js";
import { Typography as Ct } from "../components/atoms/Typography/Typography.js";
import "@mui/icons-material/KeyboardArrowDown";
import "@mui/icons-material/Warning";
import "@mui/material/styles";
import "../components/atoms/Table/Table.js";
import "../components/atoms/TableBody/TableBody.js";
import "../components/atoms/TableHead/TableHead.js";
import "../components/atoms/TableRow/TableRow.js";
import "../components/atoms/TableCell/TableCell.js";
import "../components/atoms/ToggleButton/ToggleButton.js";
import "../components/atoms/ToggleButtonGroup/ToggleButtonGroup.js";
import qr from "@mui/icons-material/ExpandMore";
import "../components/atoms/Stepper/Stepper.js";
import "../components/atoms/Step/Step.js";
import "../components/atoms/StepLabel/StepLabel.js";
import "../components/atoms/Link/Link.js";
import "../components/atoms/LoadingButton/LoadingButton.js";
import "../components/atoms/LinearProgress/LinearProgress.js";
import "../components/atoms/Stack/Stack.js";
import "../components/atoms/Card/Card.js";
import "../components/atoms/CardActions/CardActions.js";
import "../components/atoms/FormHelperText/FormHelperText.js";
import "../components/atoms/AccordionDetails/AccordionDetails.js";
import "../components/atoms/TableContainer/TableContainer.js";
import "@mui/material/DialogTitle";
import "@mui/material/DialogContent";
import "@mui/material/DialogActions";
import "@mui/material/IconButton";
import "@mui/icons-material/Close";
import "@mui/material/Typography";
import "@mui/material/Dialog";
import Kr from "@mui/icons-material/InfoOutlined";
import zi from "@mui/icons-material/ArrowDropDown";
import Jr from "@mui/icons-material/ArrowDropUp";
import Zr from "@mui/icons-material/ArrowLeft";
import Qr from "@mui/icons-material/ArrowRight";
import jr from "highcharts-react-official";
import to from "highcharts";
import jn from "moment-timezone";
import "highcharts/highcharts";
import "../components/molecules/Widgets/WidgetTimelineGraph/WidgetTimelineGraph.styles.js";
import "react-dom/client";
import { Chip as eo } from "../components/atoms/Chip/Chip.js";
import { Skeleton as Xe } from "../components/atoms/SkeletonLoader/SkeletonLoader.js";
import "reactflow";
import "reactflow/dist/style.css";
import "dagre";
import "../components/molecules/NetworkMap/NetworkMapUtils.js";
import "@mui/icons-material/FilterAlt";
/* empty css              */
import "@mui/material/Menu";
import "@mui/material/FormControl";
import "@mui/material/ListSubheader";
import "lodash";
import "@mui/icons-material/Search";
import "@mui/material/TextField";
import "@mui/material/Fab";
import "@mui/material/TextareaAutosize";
import "@mui/material/InputLabel";
import "@mui/material/CardContent";
import "@mui/material/CardHeader";
import "@mui/material/Collapse";
import "@mui/material/ClickAwayListener";
import "@mui/material/Grow";
import "@mui/material/Fade";
import "@mui/material/Popper";
import "@mui/material/MenuList";
import "@mui/material/Breadcrumbs";
import "@mui/material/Modal";
import "@mui/material/FormGroup";
import "@mui/material/Accordion";
import "@mui/material/AccordionSummary";
import "@mui/material/AccordionDetails";
import "@mui/material/Select";
import "@mui/material/Autocomplete";
import "@mui/material/InputAdornment";
import "@mui/material/AlertTitle";
import "@mui/material/ListItemText";
import "@mui/material/List";
import "@mui/material/ListItem";
import "@mui/material/ListItemButton";
import "@mui/material/ListItemAvatar";
import "@mui/material/Backdrop";
import "@mui/material/ListItemIcon";
import "@mui/material/Popover";
import "@mui/material/Drawer";
import "@mui/material/CardMedia";
import "@mui/material/Snackbar";
import "@mui/material/TablePagination";
import "@mui/material/colors";
import "@mui/material/useMediaQuery";
import "@mui/material/OutlinedInput";
import { Button as no } from "../components/atoms/Button/Button.js";
import "@mui/icons-material/CheckCircle";
import io from "@mui/icons-material/RestartAlt";
import "@mui/icons-material/Info";
import on from "@mui/icons-material/Add";
import "@mui/icons-material/Build";
import "@mui/icons-material/Menu";
import "../components/organisms/SunburstGraph/SunburstGraph.js";
import "../components/organisms/RadarGraph/RadarGraph.js";
import "../components/organisms/ScoreGauge/ScoreGauge.js";
import "@mui/icons-material/EventOutlined";
import "@mui/icons-material/KeyboardArrowDownOutlined";
import "@mui/icons-material/CloseRounded";
import "../components/organisms/DateTimeSelector/DateTimeSelectorMenu.js";
import "@mui/icons-material/KeyboardDoubleArrowLeftOutlined";
import "@mui/icons-material/KeyboardDoubleArrowRightOutlined";
import "./TableContext.js";
import "@tanstack/react-table";
import "@tanstack/react-virtual";
import "@mui/icons-material/FilterAltOff";
import "react-window";
import "../components/organisms/Table/TimeRangeFilter.js";
import "@mui/icons-material/KeyboardDoubleArrowLeft";
import "@mui/icons-material/KeyboardDoubleArrowRight";
import "@mui/icons-material/KeyboardArrowLeft";
import "@mui/icons-material/KeyboardArrowRight";
import "@mui/icons-material/ViewWeek";
import "@mui/icons-material/DragIndicator";
import "@mui/icons-material/ArrowForward";
import "./ChatbotContext.js";
import "react-markdown";
import "remark-gfm";
import "rehype-raw";
import "rehype-sanitize";
import "@mui/material/Button";
import "../components/organisms/ReactMap/GMapStatic.js";
import { ResetDialog as ro } from "../components/organisms/OverlayMap/dialogs/ResetDialog.js";
import { DeletePlanDialog as oo } from "../components/organisms/OverlayMap/dialogs/DeletePlanDialog.js";
import { c as hn, a as Tn, b as Pi, d as ao, O as xi } from "./mapUtils.js";
import lo from "../components/organisms/OverlayMap/controls/MiniControls.js";
import so from "@mui/icons-material/Fullscreen";
import co from "@mui/icons-material/FullscreenExit";
import { TRANSFORM_UPDATE_DEBOUNCE as uo, MAP_PINS_UPDATE_DEBOUNCE as fo, DEFAULT_OVERLAY_OPACITY as po, MAP_CONTROL_SIZE as mo, MAP_TYPE_CHANGE_DEBOUNCE as ho } from "../components/organisms/OverlayMap/constants.js";
import wi from "@mui/icons-material/Opacity";
import go from "@mui/icons-material/Satellite";
import yi from "@mui/icons-material/Layers";
import _o from "@mui/icons-material/SignalCellularAlt";
import Po from "@mui/icons-material/Router";
import xo from "@mui/icons-material/Edit";
import wo from "@mui/icons-material/DeleteOutlineRounded";
import yo from "@mui/icons-material/UploadFile";
import No from "@mui/icons-material/Download";
import bo from "@mui/icons-material/Map";
import vo from "@mui/icons-material/SatelliteAlt";
import "@mui/icons-material/Clear";
import Co from "../utilities/safeDownload.js";
import { getPlanIconComponent as Ao, getPlanIconsAndTooltips as Bi } from "../components/organisms/OverlayMap/utils/planIconsUtils.js";
import { useUploadDialog as Lo } from "../components/organisms/OverlayMap/hooks/useUploadDialog.js";
import { SimpleTreeView as Io } from "@mui/x-tree-view";
import Oo from "@mui/icons-material/ChevronRight";
import Mo from "../components/molecules/Tree/IconExpansionTreeItem.js";
import { updateURL as Wi } from "../utilities/url.js";
import { Tooltip as li } from "../components/atoms/Tooltip/Tooltip.js";
import { AnimationCounter as So } from "../components/atoms/Counter/AnimationCounter.js";
import { formatCompactNumber as To, getFormattedBytes as Do, formatNumber as Ro } from "../utilities/index.js";
import { CopyComponent as Fo } from "../components/atoms/CopyComponent/CopyComponent.js";
import { LegendMarker as Ni } from "../components/atoms/LegendMarker/LegendMarker.js";
import { styles as He } from "../components/molecules/Widgets/WidgetStatusText/WidgetStatusText.styles.js";
import { styles as Ln } from "../components/molecules/Widgets/WidgetMetricGraph/WidgetMetricGraph.styles.js";
function Eo(e) {
  const t = he(48);
  let n, i, r, o, a, s, l, u, f, _, m;
  t[0] !== e ? ({
    variant: l,
    width: m,
    type: u,
    height: r,
    size: f,
    sx: s,
    label: o,
    required: _,
    error: n,
    errorText: i,
    ...a
  } = e, t[0] = e, t[1] = n, t[2] = i, t[3] = r, t[4] = o, t[5] = a, t[6] = s, t[7] = l, t[8] = u, t[9] = f, t[10] = _, t[11] = m) : (n = t[1], i = t[2], r = t[3], o = t[4], a = t[5], s = t[6], l = t[7], u = t[8], f = t[9], _ = t[10], m = t[11]);
  const P = l === void 0 ? "outlined" : l, b = u === void 0 ? "text" : u, w = f === void 0 ? "small" : f, g = _ === void 0 ? !1 : _, [y, k] = _t(!1);
  let L, C;
  t[12] !== a ? ({
    endAdornment: L,
    ...C
  } = a, t[12] = a, t[13] = L, t[14] = C) : (L = t[13], C = t[14]);
  let S;
  t[15] !== y ? (S = () => {
    k(!y);
  }, t[15] = y, t[16] = S) : S = t[16];
  const V = S, q = $o, F = P === "filled" ? Ir : P === "standard" ? Or : Mr, Z = w === "medium" ? "40px" : "32px", $ = !!a.multiline, X = r ?? Z;
  let K;
  t[17] !== $ || t[18] !== X ? (K = $ ? {
    minHeight: X,
    height: "auto",
    alignItems: "flex-start",
    "& .MuiInputBase-inputMultiline": {
      boxSizing: "border-box",
      minHeight: X
    }
  } : {
    height: X
  }, t[17] = $, t[18] = X, t[19] = K) : K = t[19];
  let Q;
  t[20] !== K || t[21] !== m ? (Q = {
    width: m,
    ...K
  }, t[20] = K, t[21] = m, t[22] = Q) : Q = t[22];
  const T = Q;
  let H;
  t[23] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (H = {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
    width: "100%"
  }, t[23] = H) : H = t[23];
  let et;
  t[24] !== o || t[25] !== g ? (et = o && /* @__PURE__ */ O(Ct, { sx: ko, children: [
    o,
    g && /* @__PURE__ */ p(St, { component: "span", sx: Uo, children: " *" })
  ] }), t[24] = o, t[25] = g, t[26] = et) : et = t[26];
  let ht;
  t[27] !== F || t[28] !== T || t[29] !== L || t[30] !== n || t[31] !== V || t[32] !== C || t[33] !== a || t[34] !== g || t[35] !== y || t[36] !== w || t[37] !== s || t[38] !== b || t[39] !== P ? (ht = b === "password" ? /* @__PURE__ */ p(F, { id: "outlined-adornment-password", type: y ? "text" : "password", error: n, required: g, size: w, endAdornment: /* @__PURE__ */ O(Sr, { position: "end", children: [
    L || null,
    /* @__PURE__ */ p(pe, { "aria-label": "toggle password visibility", onClick: V, onMouseDown: q, sx: {
      p: 0.5,
      mr: "15px"
    }, children: y ? /* @__PURE__ */ p(Gr, {}) : /* @__PURE__ */ p(Xr, {}) })
  ] }), sx: [T, bi[P], ...Array.isArray(s) ? s : [s]], placeholder: C.placeholder ? C.placeholder : "", ...C }) : /* @__PURE__ */ p(F, { sx: [T, bi[P], ...Array.isArray(s) ? s : [s]], error: n, required: g, size: w, type: b, ...a }), t[27] = F, t[28] = T, t[29] = L, t[30] = n, t[31] = V, t[32] = C, t[33] = a, t[34] = g, t[35] = y, t[36] = w, t[37] = s, t[38] = b, t[39] = P, t[40] = ht) : ht = t[40];
  let ot;
  t[41] !== n || t[42] !== i ? (ot = n && i && /* @__PURE__ */ p(Ct, { sx: Vo, children: i }), t[41] = n, t[42] = i, t[43] = ot) : ot = t[43];
  let Pt;
  return t[44] !== ot || t[45] !== et || t[46] !== ht ? (Pt = /* @__PURE__ */ O(St, { sx: H, children: [
    et,
    ht,
    ot
  ] }), t[44] = ot, t[45] = et, t[46] = ht, t[47] = Pt) : Pt = t[47], Pt;
}
function $o(e) {
  e.preventDefault();
}
const bi = {
  outlined: (e) => ({
    border: `1px solid ${e.vars?.palette.grey[300] ?? "#EFEFEF"}`,
    backgroundColor: e.palette.background.paper,
    borderRadius: "8px",
    color: "#5B5B5B",
    fontSize: "12px",
    "& .MuiInputBase-input": {
      padding: "6px 16px",
      lineHeight: "20px"
    },
    "& .MuiOutlinedInput-notchedOutline": {
      border: "none"
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      border: "none"
    },
    "&.Mui-focused": {
      borderColor: e.palette.primary.main,
      borderWidth: "1px"
    }
  }),
  filled: (e) => ({
    border: `1px solid ${e.vars?.palette.grey[300] ?? "#EFEFEF"}`,
    borderRadius: "8px",
    color: "#5B5B5B",
    backgroundColor: e.palette.action.hover,
    "&:before, &:after": {
      borderBottom: "none !important"
    },
    "&:hover:not(.Mui-disabled, .Mui-error):before": {
      borderBottom: "none"
    },
    "& .MuiInputBase-input": {
      padding: "6px 16px",
      lineHeight: "20px",
      fontSize: "12px"
    },
    "&.Mui-focused": {
      borderColor: e.palette.primary.main,
      borderWidth: "1px"
    }
  }),
  standard: (e) => ({
    border: `1px solid ${e.vars?.palette.grey[300] ?? "#EFEFEF"}`,
    borderRadius: "8px",
    color: "#5B5B5B",
    "&:before, &:after": {
      borderBottom: "none !important"
    },
    "&:hover:not(.Mui-disabled, .Mui-error):before": {
      borderBottom: "none"
    },
    "& .MuiInputBase-input": {
      padding: "6px 16px",
      lineHeight: "20px",
      fontSize: "12px"
    },
    "&.Mui-focused": {
      borderColor: e.palette.primary.main,
      borderWidth: "1px"
    }
  })
}, ko = {
  fontWeight: 500,
  fontSize: "12px",
  lineHeight: "14px",
  color: "#5A5A5A"
}, Uo = {
  color: "#d32f2f"
}, Vo = {
  fontWeight: 400,
  fontSize: "12px",
  lineHeight: "14px",
  color: "#d32f2f"
};
function zo(e) {
  const t = he(9), {
    title: n,
    tooltip: i,
    TooltipIcon: r,
    key: o,
    children: a,
    gap: s
  } = e, l = s === void 0 ? 2 : s;
  let u;
  t[0] !== r || t[1] !== n || t[2] !== i ? (u = (n || i) && /* @__PURE__ */ O(rt, { container: !0, alignItems: "center", flexWrap: "nowrap", gap: 2, children: [
    n && /* @__PURE__ */ p(Ct, { type: "bodyText2", sx: {
      color: Bo,
      ...Wo.titleText
    }, children: n }),
    i && /* @__PURE__ */ p(li, { title: i, children: r ? /* @__PURE__ */ p(r, {}) : /* @__PURE__ */ p(Kr, { fontSize: "small", color: "disabled" }) })
  ] }), t[0] = r, t[1] = n, t[2] = i, t[3] = u) : u = t[3];
  let f;
  return t[4] !== a || t[5] !== l || t[6] !== o || t[7] !== u ? (f = /* @__PURE__ */ O(rt, { container: !0, direction: "column", gap: l, flexWrap: "nowrap", children: [
    u,
    a
  ] }, o), t[4] = a, t[5] = l, t[6] = o, t[7] = u, t[8] = f) : f = t[8], f;
}
function Bo(e) {
  return e.vars?.palette.grey[600] ?? e.palette.grey[600];
}
const Wo = {
  titleText: {
    textWrap: "nowrap"
  }
};
function Ho(e) {
  const t = he(15), {
    changePercentage: n,
    ChangeIcon: i,
    tooltip: r,
    TooltipIcon: o,
    title: a,
    subtext: s,
    value: l,
    unit: u,
    widgetImage: f,
    loading: _
  } = e, m = _ === void 0 ? !1 : _;
  let P = de.vars?.palette.grey[600] ?? de.palette.grey[600], b = Xo;
  n && (n > 0 ? (P = de.vars?.palette.primary.main, b = Go) : n < 0 && (P = de.vars?.palette.error.main ?? de.palette.error.main, b = Yo));
  let w;
  t[0] !== i || t[1] !== b || t[2] !== P || t[3] !== n || t[4] !== m || t[5] !== s || t[6] !== u || t[7] !== l || t[8] !== f ? (w = m ? /* @__PURE__ */ O(sn, { children: [
    /* @__PURE__ */ O(rt, { container: !0, alignItems: "center", gap: 2, children: [
      f,
      /* @__PURE__ */ p(Xe, { variant: "rounded", width: 148, height: 38 })
    ] }),
    s && /* @__PURE__ */ p(Xe, { variant: "rounded", width: "80%", height: 16 })
  ] }) : /* @__PURE__ */ O(rt, { container: !0, flexDirection: "column", gap: 1, children: [
    /* @__PURE__ */ O(rt, { container: !0, alignItems: "center", gap: 2, wrap: "nowrap", children: [
      f,
      /* @__PURE__ */ O(Ct, { type: "statistics1", sx: vi.statisticsText, children: [
        l === 0 ? l : /* @__PURE__ */ p(So, { value: l }),
        u
      ] }),
      n !== void 0 && /* @__PURE__ */ O(rt, { container: !0, width: "fit-content", height: "fit-content", gap: 0.5, marginLeft: 1, alignItems: "center", flexWrap: "nowrap", bgcolor: `${P}26`, borderRadius: 1.5, paddingX: 1, paddingY: 0.25, children: [
        i ? /* @__PURE__ */ p(i, {}) : /* @__PURE__ */ p(b, {}),
        /* @__PURE__ */ p(Ct, { type: "bodyText1", color: P, children: `${To(n, !0)}%` })
      ] })
    ] }),
    s && /* @__PURE__ */ p(Ct, { type: "bodyText3", sx: vi.subtext, children: s })
  ] }), t[0] = i, t[1] = b, t[2] = P, t[3] = n, t[4] = m, t[5] = s, t[6] = u, t[7] = l, t[8] = f, t[9] = w) : w = t[9];
  let g;
  return t[10] !== o || t[11] !== w || t[12] !== a || t[13] !== r ? (g = /* @__PURE__ */ p(zo, { title: a, tooltip: r, TooltipIcon: o, children: w }), t[10] = o, t[11] = w, t[12] = a, t[13] = r, t[14] = g) : g = t[14], g;
}
function Yo() {
  return /* @__PURE__ */ p(zi, { style: {
    color: de.vars?.palette.error.dark ?? de.palette.error.dark
  } });
}
function Go() {
  return /* @__PURE__ */ p(Jr, { style: {
    color: de.vars?.palette.primary.main ?? de.palette.primary.main
  } });
}
function Xo() {
  return /* @__PURE__ */ O(rt, { container: !0, flexWrap: "nowrap", sx: {
    rotate: "90deg"
  }, children: [
    /* @__PURE__ */ p(Zr, { color: "action" }),
    /* @__PURE__ */ p(Qr, { color: "action", style: {
      marginLeft: -14
    } })
  ] });
}
const vi = {
  statisticsText: {
    textWrap: "nowrap"
  },
  subtext: {
    opacity: 0.7
  }
};
function qo(e) {
  const t = he(31), {
    title: n,
    content: i,
    loading: r,
    gap: o,
    contentTypography: a,
    width: s
  } = e;
  let l, u, f, _, m, P, b, w, g, y;
  if (t[0] !== i || t[1] !== r || t[2] !== o || t[3] !== a || t[4] !== s || t[5] !== n) {
    const C = i === void 0 ? [] : i, S = r === void 0 ? !1 : r, V = o === void 0 ? 1 : o, q = a === void 0 ? "bodyText2" : a, F = s === void 0 ? "100%" : s, Z = {
      color: "grey",
      size: "md",
      variant: "disc"
    };
    u = rt, y = !0, f = He.container, _ = V, m = F, t[16] !== n ? (P = /* @__PURE__ */ p(Ct, { type: "bodyText3", sx: He.titleText, children: n }), t[16] = n, t[17] = P) : P = t[17], l = rt, b = !0, w = He.contentContainer, g = S ? /* @__PURE__ */ p(Xe, { variant: "rectangular", width: 100, height: 15 }) : C.map(($, X) => {
      const {
        markerOptions: K,
        text: Q,
        showMarker: T,
        showCopyIcon: H,
        showWarning: et,
        tooltipText: ht,
        extraContent: ot
      } = $;
      return /* @__PURE__ */ O(rt, { container: !0, sx: He.statusTextContainer, children: [
        T && /* @__PURE__ */ p(Ni, { ...Z, ...K }),
        /* @__PURE__ */ p(li, { title: ht, placement: "top", slotProps: {
          popper: {
            modifiers: [{
              name: "offset",
              options: {
                offset: [0, -14]
              }
            }]
          }
        }, children: /* @__PURE__ */ O(rt, { container: !0, sx: He.extraContent, children: [
          /* @__PURE__ */ p(Ct, { type: q, children: Q }),
          ot && ot.map((Pt, Ue) => {
            const {
              showMarker: ge,
              markerOptions: G,
              text: ft
            } = Pt;
            return /* @__PURE__ */ O(rt, { container: !0, sx: He.statusTextContainer, children: [
              ge && /* @__PURE__ */ p(Ni, { ...Z, ...G }),
              /* @__PURE__ */ p(Ct, { type: q, children: ft })
            ] }, `${n}-extra-content-${ft}-${Ue}`);
          })
        ] }) }),
        H && /* @__PURE__ */ p(Fo, { text: Q }),
        et && /* @__PURE__ */ p(Ur, { sx: He.warningIcon })
      ] }, `${n}-${Q}-${X}`);
    }), t[0] = i, t[1] = r, t[2] = o, t[3] = a, t[4] = s, t[5] = n, t[6] = l, t[7] = u, t[8] = f, t[9] = _, t[10] = m, t[11] = P, t[12] = b, t[13] = w, t[14] = g, t[15] = y;
  } else
    l = t[6], u = t[7], f = t[8], _ = t[9], m = t[10], P = t[11], b = t[12], w = t[13], g = t[14], y = t[15];
  let k;
  t[18] !== l || t[19] !== b || t[20] !== w || t[21] !== g ? (k = /* @__PURE__ */ p(l, { container: b, sx: w, children: g }), t[18] = l, t[19] = b, t[20] = w, t[21] = g, t[22] = k) : k = t[22];
  let L;
  return t[23] !== u || t[24] !== f || t[25] !== _ || t[26] !== m || t[27] !== P || t[28] !== k || t[29] !== y ? (L = /* @__PURE__ */ O(u, { container: y, sx: f, gap: _, width: m, children: [
    P,
    k
  ] }), t[23] = u, t[24] = f, t[25] = _, t[26] = m, t[27] = P, t[28] = k, t[29] = y, t[30] = L) : L = t[30], L;
}
function Ko(e) {
  const {
    data: t,
    subtitle: n = "Current Count",
    title: i,
    value: r,
    color: o,
    timezone: a,
    loading: s = !1,
    titleIcon: l,
    hideYAxis: u,
    hideXAxisLabel: f,
    height: _,
    lineWidth: m,
    hideCrossHair: P,
    filledMarker: b,
    padding: w = 4,
    visibleDataPointIndexes: g = [],
    tooltip: y,
    valueDescription: k
  } = e, L = Ye(() => ({
    time: {
      timezone: a,
      useUTC: !1
    },
    chart: {
      backgroundColor: "transparent",
      zooming: {
        type: "x"
      },
      height: _ || "192px",
      type: "areaspline"
    },
    credits: {
      enabled: !1
    },
    title: {
      text: ""
    },
    accessibility: {
      enabled: !1
    },
    xAxis: {
      visible: !f,
      type: "datetime",
      ...!f && {
        tickLength: 0
      },
      labels: {
        enabled: !f,
        style: {
          color: "#747982"
        },
        formatter: function() {
          return jn(this.value).tz(a).format("MMM DD<br />h:mm a");
        }
      },
      crosshair: {
        width: 1,
        color: o,
        zIndex: 5,
        dashStyle: "LongDash",
        ...P && {
          width: 0
        }
      }
    },
    legend: {
      enabled: !1
    },
    exporting: {
      enabled: !1
    },
    tooltip: {
      useHTML: !0,
      style: {
        color: "#fff",
        fontSize: "12px"
      },
      backgroundColor: "#272B2F",
      formatter: function() {
        let C = y?.unit || "", S = 0;
        if (typeof this.y == "number")
          if (y?.unit?.includes("bytes")) {
            const {
              value: V,
              unit: q
            } = Do(this.y);
            S = V, C = q;
          } else
            S = Ro(this.y);
        return `<b>${this.series.name}</b><br/>${jn(this.x).tz(a).format("MMM DD, YYYY h:mm a z")}<br />${y?.text ? y?.text + ": " : ""}<b>${typeof this.y == "number" ? S : this.y}</b> ${C}<br/>`;
      }
    },
    yAxis: {
      ...t.length === 0 && {
        min: 0,
        max: 16
      },
      visible: !u,
      gridLineDashStyle: "LongDash",
      gridLineColor: t.length >= 1 ? o : "rgba(116,121,130, 0.3)",
      labels: {
        style: {
          color: "#747982"
        }
      },
      title: {
        text: ""
      }
    },
    plotOptions: {
      series: {
        connectEnds: !0,
        connectNulls: !0,
        lineWidth: m || 2,
        color: o,
        // change Line color
        marker: {
          enabled: !1,
          fillColor: "#000",
          lineWidth: 2,
          ...b && {
            fillColor: o,
            lineWidth: 0.5
          }
        },
        states: {
          inactive: {
            opacity: 1
          }
        }
      }
    },
    series: [{
      name: i,
      type: "areaspline",
      data: t,
      fillOpacity: 0.2
    }, {
      name: i,
      type: "scatter",
      lineWidth: 0,
      marker: {
        enabled: !0,
        symbol: "circle",
        fillColor: "#000"
      },
      data: t.filter((C, S) => g.includes(S))
    }]
  }), [o, t, i, a, f, u, _, m, P, b, g, y?.text, y?.unit]);
  return (
    // Replace the following static color once it is included in the color palette
    /* @__PURE__ */ p(rt, { container: !0, flexDirection: "column", flexWrap: "nowrap", padding: w, borderRadius: 1, bgcolor: "#fff", sx: {
      width: "100%",
      minWidth: 0
    }, children: s ? /* @__PURE__ */ O(sn, { children: [
      /* @__PURE__ */ O(rt, { container: !0, justifyContent: "space-between", flexWrap: "nowrap", paddingBottom: 4, children: [
        /* @__PURE__ */ p(Xe, { width: 100, height: 20, variant: "rounded" }),
        /* @__PURE__ */ p(Xe, { width: 100, height: 20, variant: "rounded" })
      ] }),
      /* @__PURE__ */ p(Xe, { width: "100%", height: 192, variant: "rounded" })
    ] }) : /* @__PURE__ */ O(sn, { children: [
      (i || n) && /* @__PURE__ */ O(rt, { container: !0, flexWrap: "nowrap", paddingBottom: 4, justifyContent: "space-between", children: [
        /* @__PURE__ */ O(rt, { container: !0, justifyContent: "center", alignItems: "center", flexWrap: "nowrap", gap: 1, width: "fit-content", children: [
          l,
          /* @__PURE__ */ p(Ct, { type: "bodyText2", sx: {
            textTransform: "capitalize",
            color: (C) => C.vars?.palette.grey[900] ?? C.palette.grey[900]
          }, children: i })
        ] }),
        /* @__PURE__ */ O(rt, { container: !0, justifyContent: "center", alignItems: "center", flexWrap: "nowrap", gap: 1, width: "fit-content", children: [
          /* @__PURE__ */ p(Ct, { type: "bodyText3", sx: {
            color: (C) => C.vars?.palette.grey[600] ?? C.palette.grey[600]
          }, children: n }),
          /* @__PURE__ */ p(Ct, { type: "bodyText1", sx: {
            color: (C) => C.vars?.palette.grey[900] ?? C.palette.grey[900]
          }, children: r }),
          k && /* @__PURE__ */ p(li, { title: k, placement: "bottom-end", children: /* @__PURE__ */ p(Vr, { fontSize: "small", sx: {
            color: "#D7D7D7"
          } }) })
        ] })
      ] }),
      /* @__PURE__ */ p(rt, { sx: {
        position: "relative",
        width: "100%",
        minWidth: 0
      }, children: t.length !== 0 ? /* @__PURE__ */ p(jr, { highcharts: to, options: L }) : /* @__PURE__ */ p(rt, { display: "flex", justifyContent: "center", alignItems: "center", paddingY: 5, children: /* @__PURE__ */ p(Ct, { type: "heading1", children: "No data available" }) }) })
    ] }) })
  );
}
var Jo = { value: () => {
} };
function Hi() {
  for (var e = 0, t = arguments.length, n = {}, i; e < t; ++e) {
    if (!(i = arguments[e] + "") || i in n || /[\s.]/.test(i)) throw new Error("illegal type: " + i);
    n[i] = [];
  }
  return new Dn(n);
}
function Dn(e) {
  this._ = e;
}
function Zo(e, t) {
  return e.trim().split(/^|\s+/).map(function(n) {
    var i = "", r = n.indexOf(".");
    if (r >= 0 && (i = n.slice(r + 1), n = n.slice(0, r)), n && !t.hasOwnProperty(n)) throw new Error("unknown type: " + n);
    return { type: n, name: i };
  });
}
Dn.prototype = Hi.prototype = {
  constructor: Dn,
  on: function(e, t) {
    var n = this._, i = Zo(e + "", n), r, o = -1, a = i.length;
    if (arguments.length < 2) {
      for (; ++o < a; ) if ((r = (e = i[o]).type) && (r = Qo(n[r], e.name))) return r;
      return;
    }
    if (t != null && typeof t != "function") throw new Error("invalid callback: " + t);
    for (; ++o < a; )
      if (r = (e = i[o]).type) n[r] = Ci(n[r], e.name, t);
      else if (t == null) for (r in n) n[r] = Ci(n[r], e.name, null);
    return this;
  },
  copy: function() {
    var e = {}, t = this._;
    for (var n in t) e[n] = t[n].slice();
    return new Dn(e);
  },
  call: function(e, t) {
    if ((r = arguments.length - 2) > 0) for (var n = new Array(r), i = 0, r, o; i < r; ++i) n[i] = arguments[i + 2];
    if (!this._.hasOwnProperty(e)) throw new Error("unknown type: " + e);
    for (o = this._[e], i = 0, r = o.length; i < r; ++i) o[i].value.apply(t, n);
  },
  apply: function(e, t, n) {
    if (!this._.hasOwnProperty(e)) throw new Error("unknown type: " + e);
    for (var i = this._[e], r = 0, o = i.length; r < o; ++r) i[r].value.apply(t, n);
  }
};
function Qo(e, t) {
  for (var n = 0, i = e.length, r; n < i; ++n)
    if ((r = e[n]).name === t)
      return r.value;
}
function Ci(e, t, n) {
  for (var i = 0, r = e.length; i < r; ++i)
    if (e[i].name === t) {
      e[i] = Jo, e = e.slice(0, i).concat(e.slice(i + 1));
      break;
    }
  return n != null && e.push({ name: t, value: n }), e;
}
var ti = "http://www.w3.org/1999/xhtml";
const Ai = {
  svg: "http://www.w3.org/2000/svg",
  xhtml: ti,
  xlink: "http://www.w3.org/1999/xlink",
  xml: "http://www.w3.org/XML/1998/namespace",
  xmlns: "http://www.w3.org/2000/xmlns/"
};
function Bn(e) {
  var t = e += "", n = t.indexOf(":");
  return n >= 0 && (t = e.slice(0, n)) !== "xmlns" && (e = e.slice(n + 1)), Ai.hasOwnProperty(t) ? { space: Ai[t], local: e } : e;
}
function jo(e) {
  return function() {
    var t = this.ownerDocument, n = this.namespaceURI;
    return n === ti && t.documentElement.namespaceURI === ti ? t.createElement(e) : t.createElementNS(n, e);
  };
}
function ta(e) {
  return function() {
    return this.ownerDocument.createElementNS(e.space, e.local);
  };
}
function Yi(e) {
  var t = Bn(e);
  return (t.local ? ta : jo)(t);
}
function ea() {
}
function si(e) {
  return e == null ? ea : function() {
    return this.querySelector(e);
  };
}
function na(e) {
  typeof e != "function" && (e = si(e));
  for (var t = this._groups, n = t.length, i = new Array(n), r = 0; r < n; ++r)
    for (var o = t[r], a = o.length, s = i[r] = new Array(a), l, u, f = 0; f < a; ++f)
      (l = o[f]) && (u = e.call(l, l.__data__, f, o)) && ("__data__" in l && (u.__data__ = l.__data__), s[f] = u);
  return new Ut(i, this._parents);
}
function ia(e) {
  return e == null ? [] : Array.isArray(e) ? e : Array.from(e);
}
function ra() {
  return [];
}
function Gi(e) {
  return e == null ? ra : function() {
    return this.querySelectorAll(e);
  };
}
function oa(e) {
  return function() {
    return ia(e.apply(this, arguments));
  };
}
function aa(e) {
  typeof e == "function" ? e = oa(e) : e = Gi(e);
  for (var t = this._groups, n = t.length, i = [], r = [], o = 0; o < n; ++o)
    for (var a = t[o], s = a.length, l, u = 0; u < s; ++u)
      (l = a[u]) && (i.push(e.call(l, l.__data__, u, a)), r.push(l));
  return new Ut(i, r);
}
function Xi(e) {
  return function() {
    return this.matches(e);
  };
}
function qi(e) {
  return function(t) {
    return t.matches(e);
  };
}
var la = Array.prototype.find;
function sa(e) {
  return function() {
    return la.call(this.children, e);
  };
}
function ca() {
  return this.firstElementChild;
}
function ua(e) {
  return this.select(e == null ? ca : sa(typeof e == "function" ? e : qi(e)));
}
var fa = Array.prototype.filter;
function pa() {
  return Array.from(this.children);
}
function da(e) {
  return function() {
    return fa.call(this.children, e);
  };
}
function ma(e) {
  return this.selectAll(e == null ? pa : da(typeof e == "function" ? e : qi(e)));
}
function ha(e) {
  typeof e != "function" && (e = Xi(e));
  for (var t = this._groups, n = t.length, i = new Array(n), r = 0; r < n; ++r)
    for (var o = t[r], a = o.length, s = i[r] = [], l, u = 0; u < a; ++u)
      (l = o[u]) && e.call(l, l.__data__, u, o) && s.push(l);
  return new Ut(i, this._parents);
}
function Ki(e) {
  return new Array(e.length);
}
function ga() {
  return new Ut(this._enter || this._groups.map(Ki), this._parents);
}
function En(e, t) {
  this.ownerDocument = e.ownerDocument, this.namespaceURI = e.namespaceURI, this._next = null, this._parent = e, this.__data__ = t;
}
En.prototype = {
  constructor: En,
  appendChild: function(e) {
    return this._parent.insertBefore(e, this._next);
  },
  insertBefore: function(e, t) {
    return this._parent.insertBefore(e, t);
  },
  querySelector: function(e) {
    return this._parent.querySelector(e);
  },
  querySelectorAll: function(e) {
    return this._parent.querySelectorAll(e);
  }
};
function _a(e) {
  return function() {
    return e;
  };
}
function Pa(e, t, n, i, r, o) {
  for (var a = 0, s, l = t.length, u = o.length; a < u; ++a)
    (s = t[a]) ? (s.__data__ = o[a], i[a] = s) : n[a] = new En(e, o[a]);
  for (; a < l; ++a)
    (s = t[a]) && (r[a] = s);
}
function xa(e, t, n, i, r, o, a) {
  var s, l, u = /* @__PURE__ */ new Map(), f = t.length, _ = o.length, m = new Array(f), P;
  for (s = 0; s < f; ++s)
    (l = t[s]) && (m[s] = P = a.call(l, l.__data__, s, t) + "", u.has(P) ? r[s] = l : u.set(P, l));
  for (s = 0; s < _; ++s)
    P = a.call(e, o[s], s, o) + "", (l = u.get(P)) ? (i[s] = l, l.__data__ = o[s], u.delete(P)) : n[s] = new En(e, o[s]);
  for (s = 0; s < f; ++s)
    (l = t[s]) && u.get(m[s]) === l && (r[s] = l);
}
function wa(e) {
  return e.__data__;
}
function ya(e, t) {
  if (!arguments.length) return Array.from(this, wa);
  var n = t ? xa : Pa, i = this._parents, r = this._groups;
  typeof e != "function" && (e = _a(e));
  for (var o = r.length, a = new Array(o), s = new Array(o), l = new Array(o), u = 0; u < o; ++u) {
    var f = i[u], _ = r[u], m = _.length, P = Na(e.call(f, f && f.__data__, u, i)), b = P.length, w = s[u] = new Array(b), g = a[u] = new Array(b), y = l[u] = new Array(m);
    n(f, _, w, g, y, P, t);
    for (var k = 0, L = 0, C, S; k < b; ++k)
      if (C = w[k]) {
        for (k >= L && (L = k + 1); !(S = g[L]) && ++L < b; ) ;
        C._next = S || null;
      }
  }
  return a = new Ut(a, i), a._enter = s, a._exit = l, a;
}
function Na(e) {
  return typeof e == "object" && "length" in e ? e : Array.from(e);
}
function ba() {
  return new Ut(this._exit || this._groups.map(Ki), this._parents);
}
function va(e, t, n) {
  var i = this.enter(), r = this, o = this.exit();
  return typeof e == "function" ? (i = e(i), i && (i = i.selection())) : i = i.append(e + ""), t != null && (r = t(r), r && (r = r.selection())), n == null ? o.remove() : n(o), i && r ? i.merge(r).order() : r;
}
function Ca(e) {
  for (var t = e.selection ? e.selection() : e, n = this._groups, i = t._groups, r = n.length, o = i.length, a = Math.min(r, o), s = new Array(r), l = 0; l < a; ++l)
    for (var u = n[l], f = i[l], _ = u.length, m = s[l] = new Array(_), P, b = 0; b < _; ++b)
      (P = u[b] || f[b]) && (m[b] = P);
  for (; l < r; ++l)
    s[l] = n[l];
  return new Ut(s, this._parents);
}
function Aa() {
  for (var e = this._groups, t = -1, n = e.length; ++t < n; )
    for (var i = e[t], r = i.length - 1, o = i[r], a; --r >= 0; )
      (a = i[r]) && (o && a.compareDocumentPosition(o) ^ 4 && o.parentNode.insertBefore(a, o), o = a);
  return this;
}
function La(e) {
  e || (e = Ia);
  function t(_, m) {
    return _ && m ? e(_.__data__, m.__data__) : !_ - !m;
  }
  for (var n = this._groups, i = n.length, r = new Array(i), o = 0; o < i; ++o) {
    for (var a = n[o], s = a.length, l = r[o] = new Array(s), u, f = 0; f < s; ++f)
      (u = a[f]) && (l[f] = u);
    l.sort(t);
  }
  return new Ut(r, this._parents).order();
}
function Ia(e, t) {
  return e < t ? -1 : e > t ? 1 : e >= t ? 0 : NaN;
}
function Oa() {
  var e = arguments[0];
  return arguments[0] = this, e.apply(null, arguments), this;
}
function Ma() {
  return Array.from(this);
}
function Sa() {
  for (var e = this._groups, t = 0, n = e.length; t < n; ++t)
    for (var i = e[t], r = 0, o = i.length; r < o; ++r) {
      var a = i[r];
      if (a) return a;
    }
  return null;
}
function Ta() {
  let e = 0;
  for (const t of this) ++e;
  return e;
}
function Da() {
  return !this.node();
}
function Ra(e) {
  for (var t = this._groups, n = 0, i = t.length; n < i; ++n)
    for (var r = t[n], o = 0, a = r.length, s; o < a; ++o)
      (s = r[o]) && e.call(s, s.__data__, o, r);
  return this;
}
function Fa(e) {
  return function() {
    this.removeAttribute(e);
  };
}
function Ea(e) {
  return function() {
    this.removeAttributeNS(e.space, e.local);
  };
}
function $a(e, t) {
  return function() {
    this.setAttribute(e, t);
  };
}
function ka(e, t) {
  return function() {
    this.setAttributeNS(e.space, e.local, t);
  };
}
function Ua(e, t) {
  return function() {
    var n = t.apply(this, arguments);
    n == null ? this.removeAttribute(e) : this.setAttribute(e, n);
  };
}
function Va(e, t) {
  return function() {
    var n = t.apply(this, arguments);
    n == null ? this.removeAttributeNS(e.space, e.local) : this.setAttributeNS(e.space, e.local, n);
  };
}
function za(e, t) {
  var n = Bn(e);
  if (arguments.length < 2) {
    var i = this.node();
    return n.local ? i.getAttributeNS(n.space, n.local) : i.getAttribute(n);
  }
  return this.each((t == null ? n.local ? Ea : Fa : typeof t == "function" ? n.local ? Va : Ua : n.local ? ka : $a)(n, t));
}
function Ji(e) {
  return e.ownerDocument && e.ownerDocument.defaultView || e.document && e || e.defaultView;
}
function Ba(e) {
  return function() {
    this.style.removeProperty(e);
  };
}
function Wa(e, t, n) {
  return function() {
    this.style.setProperty(e, t, n);
  };
}
function Ha(e, t, n) {
  return function() {
    var i = t.apply(this, arguments);
    i == null ? this.style.removeProperty(e) : this.style.setProperty(e, i, n);
  };
}
function Ya(e, t, n) {
  return arguments.length > 1 ? this.each((t == null ? Ba : typeof t == "function" ? Ha : Wa)(e, t, n ?? "")) : cn(this.node(), e);
}
function cn(e, t) {
  return e.style.getPropertyValue(t) || Ji(e).getComputedStyle(e, null).getPropertyValue(t);
}
function Ga(e) {
  return function() {
    delete this[e];
  };
}
function Xa(e, t) {
  return function() {
    this[e] = t;
  };
}
function qa(e, t) {
  return function() {
    var n = t.apply(this, arguments);
    n == null ? delete this[e] : this[e] = n;
  };
}
function Ka(e, t) {
  return arguments.length > 1 ? this.each((t == null ? Ga : typeof t == "function" ? qa : Xa)(e, t)) : this.node()[e];
}
function Zi(e) {
  return e.trim().split(/^|\s+/);
}
function ci(e) {
  return e.classList || new Qi(e);
}
function Qi(e) {
  this._node = e, this._names = Zi(e.getAttribute("class") || "");
}
Qi.prototype = {
  add: function(e) {
    var t = this._names.indexOf(e);
    t < 0 && (this._names.push(e), this._node.setAttribute("class", this._names.join(" ")));
  },
  remove: function(e) {
    var t = this._names.indexOf(e);
    t >= 0 && (this._names.splice(t, 1), this._node.setAttribute("class", this._names.join(" ")));
  },
  contains: function(e) {
    return this._names.indexOf(e) >= 0;
  }
};
function ji(e, t) {
  for (var n = ci(e), i = -1, r = t.length; ++i < r; ) n.add(t[i]);
}
function tr(e, t) {
  for (var n = ci(e), i = -1, r = t.length; ++i < r; ) n.remove(t[i]);
}
function Ja(e) {
  return function() {
    ji(this, e);
  };
}
function Za(e) {
  return function() {
    tr(this, e);
  };
}
function Qa(e, t) {
  return function() {
    (t.apply(this, arguments) ? ji : tr)(this, e);
  };
}
function ja(e, t) {
  var n = Zi(e + "");
  if (arguments.length < 2) {
    for (var i = ci(this.node()), r = -1, o = n.length; ++r < o; ) if (!i.contains(n[r])) return !1;
    return !0;
  }
  return this.each((typeof t == "function" ? Qa : t ? Ja : Za)(n, t));
}
function tl() {
  this.textContent = "";
}
function el(e) {
  return function() {
    this.textContent = e;
  };
}
function nl(e) {
  return function() {
    var t = e.apply(this, arguments);
    this.textContent = t ?? "";
  };
}
function il(e) {
  return arguments.length ? this.each(e == null ? tl : (typeof e == "function" ? nl : el)(e)) : this.node().textContent;
}
function rl() {
  this.innerHTML = "";
}
function ol(e) {
  return function() {
    this.innerHTML = e;
  };
}
function al(e) {
  return function() {
    var t = e.apply(this, arguments);
    this.innerHTML = t ?? "";
  };
}
function ll(e) {
  return arguments.length ? this.each(e == null ? rl : (typeof e == "function" ? al : ol)(e)) : this.node().innerHTML;
}
function sl() {
  this.nextSibling && this.parentNode.appendChild(this);
}
function cl() {
  return this.each(sl);
}
function ul() {
  this.previousSibling && this.parentNode.insertBefore(this, this.parentNode.firstChild);
}
function fl() {
  return this.each(ul);
}
function pl(e) {
  var t = typeof e == "function" ? e : Yi(e);
  return this.select(function() {
    return this.appendChild(t.apply(this, arguments));
  });
}
function dl() {
  return null;
}
function ml(e, t) {
  var n = typeof e == "function" ? e : Yi(e), i = t == null ? dl : typeof t == "function" ? t : si(t);
  return this.select(function() {
    return this.insertBefore(n.apply(this, arguments), i.apply(this, arguments) || null);
  });
}
function hl() {
  var e = this.parentNode;
  e && e.removeChild(this);
}
function gl() {
  return this.each(hl);
}
function _l() {
  var e = this.cloneNode(!1), t = this.parentNode;
  return t ? t.insertBefore(e, this.nextSibling) : e;
}
function Pl() {
  var e = this.cloneNode(!0), t = this.parentNode;
  return t ? t.insertBefore(e, this.nextSibling) : e;
}
function xl(e) {
  return this.select(e ? Pl : _l);
}
function wl(e) {
  return arguments.length ? this.property("__data__", e) : this.node().__data__;
}
function yl(e) {
  return function(t) {
    e.call(this, t, this.__data__);
  };
}
function Nl(e) {
  return e.trim().split(/^|\s+/).map(function(t) {
    var n = "", i = t.indexOf(".");
    return i >= 0 && (n = t.slice(i + 1), t = t.slice(0, i)), { type: t, name: n };
  });
}
function bl(e) {
  return function() {
    var t = this.__on;
    if (t) {
      for (var n = 0, i = -1, r = t.length, o; n < r; ++n)
        o = t[n], (!e.type || o.type === e.type) && o.name === e.name ? this.removeEventListener(o.type, o.listener, o.options) : t[++i] = o;
      ++i ? t.length = i : delete this.__on;
    }
  };
}
function vl(e, t, n) {
  return function() {
    var i = this.__on, r, o = yl(t);
    if (i) {
      for (var a = 0, s = i.length; a < s; ++a)
        if ((r = i[a]).type === e.type && r.name === e.name) {
          this.removeEventListener(r.type, r.listener, r.options), this.addEventListener(r.type, r.listener = o, r.options = n), r.value = t;
          return;
        }
    }
    this.addEventListener(e.type, o, n), r = { type: e.type, name: e.name, value: t, listener: o, options: n }, i ? i.push(r) : this.__on = [r];
  };
}
function Cl(e, t, n) {
  var i = Nl(e + ""), r, o = i.length, a;
  if (arguments.length < 2) {
    var s = this.node().__on;
    if (s) {
      for (var l = 0, u = s.length, f; l < u; ++l)
        for (r = 0, f = s[l]; r < o; ++r)
          if ((a = i[r]).type === f.type && a.name === f.name)
            return f.value;
    }
    return;
  }
  for (s = t ? vl : bl, r = 0; r < o; ++r) this.each(s(i[r], t, n));
  return this;
}
function er(e, t, n) {
  var i = Ji(e), r = i.CustomEvent;
  typeof r == "function" ? r = new r(t, n) : (r = i.document.createEvent("Event"), n ? (r.initEvent(t, n.bubbles, n.cancelable), r.detail = n.detail) : r.initEvent(t, !1, !1)), e.dispatchEvent(r);
}
function Al(e, t) {
  return function() {
    return er(this, e, t);
  };
}
function Ll(e, t) {
  return function() {
    return er(this, e, t.apply(this, arguments));
  };
}
function Il(e, t) {
  return this.each((typeof t == "function" ? Ll : Al)(e, t));
}
function* Ol() {
  for (var e = this._groups, t = 0, n = e.length; t < n; ++t)
    for (var i = e[t], r = 0, o = i.length, a; r < o; ++r)
      (a = i[r]) && (yield a);
}
var Ml = [null];
function Ut(e, t) {
  this._groups = e, this._parents = t;
}
function vn() {
  return new Ut([[document.documentElement]], Ml);
}
function Sl() {
  return this;
}
Ut.prototype = vn.prototype = {
  constructor: Ut,
  select: na,
  selectAll: aa,
  selectChild: ua,
  selectChildren: ma,
  filter: ha,
  data: ya,
  enter: ga,
  exit: ba,
  join: va,
  merge: Ca,
  selection: Sl,
  order: Aa,
  sort: La,
  call: Oa,
  nodes: Ma,
  node: Sa,
  size: Ta,
  empty: Da,
  each: Ra,
  attr: za,
  style: Ya,
  property: Ka,
  classed: ja,
  text: il,
  html: ll,
  raise: cl,
  lower: fl,
  append: pl,
  insert: ml,
  remove: gl,
  clone: xl,
  datum: wl,
  on: Cl,
  dispatch: Il,
  [Symbol.iterator]: Ol
};
function ui(e, t, n) {
  e.prototype = t.prototype = n, n.constructor = e;
}
function nr(e, t) {
  var n = Object.create(e.prototype);
  for (var i in t) n[i] = t[i];
  return n;
}
function Cn() {
}
var wn = 0.7, $n = 1 / wn, ln = "\\s*([+-]?\\d+)\\s*", yn = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", qt = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", Tl = /^#([0-9a-f]{3,8})$/, Dl = new RegExp(`^rgb\\(${ln},${ln},${ln}\\)$`), Rl = new RegExp(`^rgb\\(${qt},${qt},${qt}\\)$`), Fl = new RegExp(`^rgba\\(${ln},${ln},${ln},${yn}\\)$`), El = new RegExp(`^rgba\\(${qt},${qt},${qt},${yn}\\)$`), $l = new RegExp(`^hsl\\(${yn},${qt},${qt}\\)$`), kl = new RegExp(`^hsla\\(${yn},${qt},${qt},${yn}\\)$`), Li = {
  aliceblue: 15792383,
  antiquewhite: 16444375,
  aqua: 65535,
  aquamarine: 8388564,
  azure: 15794175,
  beige: 16119260,
  bisque: 16770244,
  black: 0,
  blanchedalmond: 16772045,
  blue: 255,
  blueviolet: 9055202,
  brown: 10824234,
  burlywood: 14596231,
  cadetblue: 6266528,
  chartreuse: 8388352,
  chocolate: 13789470,
  coral: 16744272,
  cornflowerblue: 6591981,
  cornsilk: 16775388,
  crimson: 14423100,
  cyan: 65535,
  darkblue: 139,
  darkcyan: 35723,
  darkgoldenrod: 12092939,
  darkgray: 11119017,
  darkgreen: 25600,
  darkgrey: 11119017,
  darkkhaki: 12433259,
  darkmagenta: 9109643,
  darkolivegreen: 5597999,
  darkorange: 16747520,
  darkorchid: 10040012,
  darkred: 9109504,
  darksalmon: 15308410,
  darkseagreen: 9419919,
  darkslateblue: 4734347,
  darkslategray: 3100495,
  darkslategrey: 3100495,
  darkturquoise: 52945,
  darkviolet: 9699539,
  deeppink: 16716947,
  deepskyblue: 49151,
  dimgray: 6908265,
  dimgrey: 6908265,
  dodgerblue: 2003199,
  firebrick: 11674146,
  floralwhite: 16775920,
  forestgreen: 2263842,
  fuchsia: 16711935,
  gainsboro: 14474460,
  ghostwhite: 16316671,
  gold: 16766720,
  goldenrod: 14329120,
  gray: 8421504,
  green: 32768,
  greenyellow: 11403055,
  grey: 8421504,
  honeydew: 15794160,
  hotpink: 16738740,
  indianred: 13458524,
  indigo: 4915330,
  ivory: 16777200,
  khaki: 15787660,
  lavender: 15132410,
  lavenderblush: 16773365,
  lawngreen: 8190976,
  lemonchiffon: 16775885,
  lightblue: 11393254,
  lightcoral: 15761536,
  lightcyan: 14745599,
  lightgoldenrodyellow: 16448210,
  lightgray: 13882323,
  lightgreen: 9498256,
  lightgrey: 13882323,
  lightpink: 16758465,
  lightsalmon: 16752762,
  lightseagreen: 2142890,
  lightskyblue: 8900346,
  lightslategray: 7833753,
  lightslategrey: 7833753,
  lightsteelblue: 11584734,
  lightyellow: 16777184,
  lime: 65280,
  limegreen: 3329330,
  linen: 16445670,
  magenta: 16711935,
  maroon: 8388608,
  mediumaquamarine: 6737322,
  mediumblue: 205,
  mediumorchid: 12211667,
  mediumpurple: 9662683,
  mediumseagreen: 3978097,
  mediumslateblue: 8087790,
  mediumspringgreen: 64154,
  mediumturquoise: 4772300,
  mediumvioletred: 13047173,
  midnightblue: 1644912,
  mintcream: 16121850,
  mistyrose: 16770273,
  moccasin: 16770229,
  navajowhite: 16768685,
  navy: 128,
  oldlace: 16643558,
  olive: 8421376,
  olivedrab: 7048739,
  orange: 16753920,
  orangered: 16729344,
  orchid: 14315734,
  palegoldenrod: 15657130,
  palegreen: 10025880,
  paleturquoise: 11529966,
  palevioletred: 14381203,
  papayawhip: 16773077,
  peachpuff: 16767673,
  peru: 13468991,
  pink: 16761035,
  plum: 14524637,
  powderblue: 11591910,
  purple: 8388736,
  rebeccapurple: 6697881,
  red: 16711680,
  rosybrown: 12357519,
  royalblue: 4286945,
  saddlebrown: 9127187,
  salmon: 16416882,
  sandybrown: 16032864,
  seagreen: 3050327,
  seashell: 16774638,
  sienna: 10506797,
  silver: 12632256,
  skyblue: 8900331,
  slateblue: 6970061,
  slategray: 7372944,
  slategrey: 7372944,
  snow: 16775930,
  springgreen: 65407,
  steelblue: 4620980,
  tan: 13808780,
  teal: 32896,
  thistle: 14204888,
  tomato: 16737095,
  turquoise: 4251856,
  violet: 15631086,
  wheat: 16113331,
  white: 16777215,
  whitesmoke: 16119285,
  yellow: 16776960,
  yellowgreen: 10145074
};
ui(Cn, Nn, {
  copy(e) {
    return Object.assign(new this.constructor(), this, e);
  },
  displayable() {
    return this.rgb().displayable();
  },
  hex: Ii,
  // Deprecated! Use color.formatHex.
  formatHex: Ii,
  formatHex8: Ul,
  formatHsl: Vl,
  formatRgb: Oi,
  toString: Oi
});
function Ii() {
  return this.rgb().formatHex();
}
function Ul() {
  return this.rgb().formatHex8();
}
function Vl() {
  return ir(this).formatHsl();
}
function Oi() {
  return this.rgb().formatRgb();
}
function Nn(e) {
  var t, n;
  return e = (e + "").trim().toLowerCase(), (t = Tl.exec(e)) ? (n = t[1].length, t = parseInt(t[1], 16), n === 6 ? Mi(t) : n === 3 ? new Lt(t >> 8 & 15 | t >> 4 & 240, t >> 4 & 15 | t & 240, (t & 15) << 4 | t & 15, 1) : n === 8 ? In(t >> 24 & 255, t >> 16 & 255, t >> 8 & 255, (t & 255) / 255) : n === 4 ? In(t >> 12 & 15 | t >> 8 & 240, t >> 8 & 15 | t >> 4 & 240, t >> 4 & 15 | t & 240, ((t & 15) << 4 | t & 15) / 255) : null) : (t = Dl.exec(e)) ? new Lt(t[1], t[2], t[3], 1) : (t = Rl.exec(e)) ? new Lt(t[1] * 255 / 100, t[2] * 255 / 100, t[3] * 255 / 100, 1) : (t = Fl.exec(e)) ? In(t[1], t[2], t[3], t[4]) : (t = El.exec(e)) ? In(t[1] * 255 / 100, t[2] * 255 / 100, t[3] * 255 / 100, t[4]) : (t = $l.exec(e)) ? Di(t[1], t[2] / 100, t[3] / 100, 1) : (t = kl.exec(e)) ? Di(t[1], t[2] / 100, t[3] / 100, t[4]) : Li.hasOwnProperty(e) ? Mi(Li[e]) : e === "transparent" ? new Lt(NaN, NaN, NaN, 0) : null;
}
function Mi(e) {
  return new Lt(e >> 16 & 255, e >> 8 & 255, e & 255, 1);
}
function In(e, t, n, i) {
  return i <= 0 && (e = t = n = NaN), new Lt(e, t, n, i);
}
function zl(e) {
  return e instanceof Cn || (e = Nn(e)), e ? (e = e.rgb(), new Lt(e.r, e.g, e.b, e.opacity)) : new Lt();
}
function ei(e, t, n, i) {
  return arguments.length === 1 ? zl(e) : new Lt(e, t, n, i ?? 1);
}
function Lt(e, t, n, i) {
  this.r = +e, this.g = +t, this.b = +n, this.opacity = +i;
}
ui(Lt, ei, nr(Cn, {
  brighter(e) {
    return e = e == null ? $n : Math.pow($n, e), new Lt(this.r * e, this.g * e, this.b * e, this.opacity);
  },
  darker(e) {
    return e = e == null ? wn : Math.pow(wn, e), new Lt(this.r * e, this.g * e, this.b * e, this.opacity);
  },
  rgb() {
    return this;
  },
  clamp() {
    return new Lt(qe(this.r), qe(this.g), qe(this.b), kn(this.opacity));
  },
  displayable() {
    return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
  },
  hex: Si,
  // Deprecated! Use color.formatHex.
  formatHex: Si,
  formatHex8: Bl,
  formatRgb: Ti,
  toString: Ti
}));
function Si() {
  return `#${Ge(this.r)}${Ge(this.g)}${Ge(this.b)}`;
}
function Bl() {
  return `#${Ge(this.r)}${Ge(this.g)}${Ge(this.b)}${Ge((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function Ti() {
  const e = kn(this.opacity);
  return `${e === 1 ? "rgb(" : "rgba("}${qe(this.r)}, ${qe(this.g)}, ${qe(this.b)}${e === 1 ? ")" : `, ${e})`}`;
}
function kn(e) {
  return isNaN(e) ? 1 : Math.max(0, Math.min(1, e));
}
function qe(e) {
  return Math.max(0, Math.min(255, Math.round(e) || 0));
}
function Ge(e) {
  return e = qe(e), (e < 16 ? "0" : "") + e.toString(16);
}
function Di(e, t, n, i) {
  return i <= 0 ? e = t = n = NaN : n <= 0 || n >= 1 ? e = t = NaN : t <= 0 && (e = NaN), new kt(e, t, n, i);
}
function ir(e) {
  if (e instanceof kt) return new kt(e.h, e.s, e.l, e.opacity);
  if (e instanceof Cn || (e = Nn(e)), !e) return new kt();
  if (e instanceof kt) return e;
  e = e.rgb();
  var t = e.r / 255, n = e.g / 255, i = e.b / 255, r = Math.min(t, n, i), o = Math.max(t, n, i), a = NaN, s = o - r, l = (o + r) / 2;
  return s ? (t === o ? a = (n - i) / s + (n < i) * 6 : n === o ? a = (i - t) / s + 2 : a = (t - n) / s + 4, s /= l < 0.5 ? o + r : 2 - o - r, a *= 60) : s = l > 0 && l < 1 ? 0 : a, new kt(a, s, l, e.opacity);
}
function Wl(e, t, n, i) {
  return arguments.length === 1 ? ir(e) : new kt(e, t, n, i ?? 1);
}
function kt(e, t, n, i) {
  this.h = +e, this.s = +t, this.l = +n, this.opacity = +i;
}
ui(kt, Wl, nr(Cn, {
  brighter(e) {
    return e = e == null ? $n : Math.pow($n, e), new kt(this.h, this.s, this.l * e, this.opacity);
  },
  darker(e) {
    return e = e == null ? wn : Math.pow(wn, e), new kt(this.h, this.s, this.l * e, this.opacity);
  },
  rgb() {
    var e = this.h % 360 + (this.h < 0) * 360, t = isNaN(e) || isNaN(this.s) ? 0 : this.s, n = this.l, i = n + (n < 0.5 ? n : 1 - n) * t, r = 2 * n - i;
    return new Lt(
      Jn(e >= 240 ? e - 240 : e + 120, r, i),
      Jn(e, r, i),
      Jn(e < 120 ? e + 240 : e - 120, r, i),
      this.opacity
    );
  },
  clamp() {
    return new kt(Ri(this.h), On(this.s), On(this.l), kn(this.opacity));
  },
  displayable() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
  },
  formatHsl() {
    const e = kn(this.opacity);
    return `${e === 1 ? "hsl(" : "hsla("}${Ri(this.h)}, ${On(this.s) * 100}%, ${On(this.l) * 100}%${e === 1 ? ")" : `, ${e})`}`;
  }
}));
function Ri(e) {
  return e = (e || 0) % 360, e < 0 ? e + 360 : e;
}
function On(e) {
  return Math.max(0, Math.min(1, e || 0));
}
function Jn(e, t, n) {
  return (e < 60 ? t + (n - t) * e / 60 : e < 180 ? n : e < 240 ? t + (n - t) * (240 - e) / 60 : t) * 255;
}
const rr = (e) => () => e;
function Hl(e, t) {
  return function(n) {
    return e + n * t;
  };
}
function Yl(e, t, n) {
  return e = Math.pow(e, n), t = Math.pow(t, n) - e, n = 1 / n, function(i) {
    return Math.pow(e + i * t, n);
  };
}
function Gl(e) {
  return (e = +e) == 1 ? or : function(t, n) {
    return n - t ? Yl(t, n, e) : rr(isNaN(t) ? n : t);
  };
}
function or(e, t) {
  var n = t - e;
  return n ? Hl(e, n) : rr(isNaN(e) ? t : e);
}
const Fi = (function e(t) {
  var n = Gl(t);
  function i(r, o) {
    var a = n((r = ei(r)).r, (o = ei(o)).r), s = n(r.g, o.g), l = n(r.b, o.b), u = or(r.opacity, o.opacity);
    return function(f) {
      return r.r = a(f), r.g = s(f), r.b = l(f), r.opacity = u(f), r + "";
    };
  }
  return i.gamma = e, i;
})(1);
function ke(e, t) {
  return e = +e, t = +t, function(n) {
    return e * (1 - n) + t * n;
  };
}
var ni = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, Zn = new RegExp(ni.source, "g");
function Xl(e) {
  return function() {
    return e;
  };
}
function ql(e) {
  return function(t) {
    return e(t) + "";
  };
}
function Kl(e, t) {
  var n = ni.lastIndex = Zn.lastIndex = 0, i, r, o, a = -1, s = [], l = [];
  for (e = e + "", t = t + ""; (i = ni.exec(e)) && (r = Zn.exec(t)); )
    (o = r.index) > n && (o = t.slice(n, o), s[a] ? s[a] += o : s[++a] = o), (i = i[0]) === (r = r[0]) ? s[a] ? s[a] += r : s[++a] = r : (s[++a] = null, l.push({ i: a, x: ke(i, r) })), n = Zn.lastIndex;
  return n < t.length && (o = t.slice(n), s[a] ? s[a] += o : s[++a] = o), s.length < 2 ? l[0] ? ql(l[0].x) : Xl(t) : (t = l.length, function(u) {
    for (var f = 0, _; f < t; ++f) s[(_ = l[f]).i] = _.x(u);
    return s.join("");
  });
}
var Ei = 180 / Math.PI, ii = {
  translateX: 0,
  translateY: 0,
  rotate: 0,
  skewX: 0,
  scaleX: 1,
  scaleY: 1
};
function ar(e, t, n, i, r, o) {
  var a, s, l;
  return (a = Math.sqrt(e * e + t * t)) && (e /= a, t /= a), (l = e * n + t * i) && (n -= e * l, i -= t * l), (s = Math.sqrt(n * n + i * i)) && (n /= s, i /= s, l /= s), e * i < t * n && (e = -e, t = -t, l = -l, a = -a), {
    translateX: r,
    translateY: o,
    rotate: Math.atan2(t, e) * Ei,
    skewX: Math.atan(l) * Ei,
    scaleX: a,
    scaleY: s
  };
}
var Mn;
function Jl(e) {
  const t = new (typeof DOMMatrix == "function" ? DOMMatrix : WebKitCSSMatrix)(e + "");
  return t.isIdentity ? ii : ar(t.a, t.b, t.c, t.d, t.e, t.f);
}
function Zl(e) {
  return e == null || (Mn || (Mn = document.createElementNS("http://www.w3.org/2000/svg", "g")), Mn.setAttribute("transform", e), !(e = Mn.transform.baseVal.consolidate())) ? ii : (e = e.matrix, ar(e.a, e.b, e.c, e.d, e.e, e.f));
}
function lr(e, t, n, i) {
  function r(u) {
    return u.length ? u.pop() + " " : "";
  }
  function o(u, f, _, m, P, b) {
    if (u !== _ || f !== m) {
      var w = P.push("translate(", null, t, null, n);
      b.push({ i: w - 4, x: ke(u, _) }, { i: w - 2, x: ke(f, m) });
    } else (_ || m) && P.push("translate(" + _ + t + m + n);
  }
  function a(u, f, _, m) {
    u !== f ? (u - f > 180 ? f += 360 : f - u > 180 && (u += 360), m.push({ i: _.push(r(_) + "rotate(", null, i) - 2, x: ke(u, f) })) : f && _.push(r(_) + "rotate(" + f + i);
  }
  function s(u, f, _, m) {
    u !== f ? m.push({ i: _.push(r(_) + "skewX(", null, i) - 2, x: ke(u, f) }) : f && _.push(r(_) + "skewX(" + f + i);
  }
  function l(u, f, _, m, P, b) {
    if (u !== _ || f !== m) {
      var w = P.push(r(P) + "scale(", null, ",", null, ")");
      b.push({ i: w - 4, x: ke(u, _) }, { i: w - 2, x: ke(f, m) });
    } else (_ !== 1 || m !== 1) && P.push(r(P) + "scale(" + _ + "," + m + ")");
  }
  return function(u, f) {
    var _ = [], m = [];
    return u = e(u), f = e(f), o(u.translateX, u.translateY, f.translateX, f.translateY, _, m), a(u.rotate, f.rotate, _, m), s(u.skewX, f.skewX, _, m), l(u.scaleX, u.scaleY, f.scaleX, f.scaleY, _, m), u = f = null, function(P) {
      for (var b = -1, w = m.length, g; ++b < w; ) _[(g = m[b]).i] = g.x(P);
      return _.join("");
    };
  };
}
var Ql = lr(Jl, "px, ", "px)", "deg)"), jl = lr(Zl, ", ", ")", ")"), un = 0, _n = 0, gn = 0, sr = 1e3, Un, Pn, Vn = 0, Ke = 0, Wn = 0, bn = typeof performance == "object" && performance.now ? performance : Date, cr = typeof window == "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(e) {
  setTimeout(e, 17);
};
function fi() {
  return Ke || (cr(ts), Ke = bn.now() + Wn);
}
function ts() {
  Ke = 0;
}
function zn() {
  this._call = this._time = this._next = null;
}
zn.prototype = ur.prototype = {
  constructor: zn,
  restart: function(e, t, n) {
    if (typeof e != "function") throw new TypeError("callback is not a function");
    n = (n == null ? fi() : +n) + (t == null ? 0 : +t), !this._next && Pn !== this && (Pn ? Pn._next = this : Un = this, Pn = this), this._call = e, this._time = n, ri();
  },
  stop: function() {
    this._call && (this._call = null, this._time = 1 / 0, ri());
  }
};
function ur(e, t, n) {
  var i = new zn();
  return i.restart(e, t, n), i;
}
function es() {
  fi(), ++un;
  for (var e = Un, t; e; )
    (t = Ke - e._time) >= 0 && e._call.call(void 0, t), e = e._next;
  --un;
}
function $i() {
  Ke = (Vn = bn.now()) + Wn, un = _n = 0;
  try {
    es();
  } finally {
    un = 0, is(), Ke = 0;
  }
}
function ns() {
  var e = bn.now(), t = e - Vn;
  t > sr && (Wn -= t, Vn = e);
}
function is() {
  for (var e, t = Un, n, i = 1 / 0; t; )
    t._call ? (i > t._time && (i = t._time), e = t, t = t._next) : (n = t._next, t._next = null, t = e ? e._next = n : Un = n);
  Pn = e, ri(i);
}
function ri(e) {
  if (!un) {
    _n && (_n = clearTimeout(_n));
    var t = e - Ke;
    t > 24 ? (e < 1 / 0 && (_n = setTimeout($i, e - bn.now() - Wn)), gn && (gn = clearInterval(gn))) : (gn || (Vn = bn.now(), gn = setInterval(ns, sr)), un = 1, cr($i));
  }
}
function ki(e, t, n) {
  var i = new zn();
  return t = t == null ? 0 : +t, i.restart((r) => {
    i.stop(), e(r + t);
  }, t, n), i;
}
var rs = Hi("start", "end", "cancel", "interrupt"), os = [], fr = 0, Ui = 1, oi = 2, Rn = 3, Vi = 4, ai = 5, Fn = 6;
function Hn(e, t, n, i, r, o) {
  var a = e.__transition;
  if (!a) e.__transition = {};
  else if (n in a) return;
  as(e, n, {
    name: t,
    index: i,
    // For context during callback.
    group: r,
    // For context during callback.
    on: rs,
    tween: os,
    time: o.time,
    delay: o.delay,
    duration: o.duration,
    ease: o.ease,
    timer: null,
    state: fr
  });
}
function pi(e, t) {
  var n = Vt(e, t);
  if (n.state > fr) throw new Error("too late; already scheduled");
  return n;
}
function Kt(e, t) {
  var n = Vt(e, t);
  if (n.state > Rn) throw new Error("too late; already running");
  return n;
}
function Vt(e, t) {
  var n = e.__transition;
  if (!n || !(n = n[t])) throw new Error("transition not found");
  return n;
}
function as(e, t, n) {
  var i = e.__transition, r;
  i[t] = n, n.timer = ur(o, 0, n.time);
  function o(u) {
    n.state = Ui, n.timer.restart(a, n.delay, n.time), n.delay <= u && a(u - n.delay);
  }
  function a(u) {
    var f, _, m, P;
    if (n.state !== Ui) return l();
    for (f in i)
      if (P = i[f], P.name === n.name) {
        if (P.state === Rn) return ki(a);
        P.state === Vi ? (P.state = Fn, P.timer.stop(), P.on.call("interrupt", e, e.__data__, P.index, P.group), delete i[f]) : +f < t && (P.state = Fn, P.timer.stop(), P.on.call("cancel", e, e.__data__, P.index, P.group), delete i[f]);
      }
    if (ki(function() {
      n.state === Rn && (n.state = Vi, n.timer.restart(s, n.delay, n.time), s(u));
    }), n.state = oi, n.on.call("start", e, e.__data__, n.index, n.group), n.state === oi) {
      for (n.state = Rn, r = new Array(m = n.tween.length), f = 0, _ = -1; f < m; ++f)
        (P = n.tween[f].value.call(e, e.__data__, n.index, n.group)) && (r[++_] = P);
      r.length = _ + 1;
    }
  }
  function s(u) {
    for (var f = u < n.duration ? n.ease.call(null, u / n.duration) : (n.timer.restart(l), n.state = ai, 1), _ = -1, m = r.length; ++_ < m; )
      r[_].call(e, f);
    n.state === ai && (n.on.call("end", e, e.__data__, n.index, n.group), l());
  }
  function l() {
    n.state = Fn, n.timer.stop(), delete i[t];
    for (var u in i) return;
    delete e.__transition;
  }
}
function ls(e, t) {
  var n = e.__transition, i, r, o = !0, a;
  if (n) {
    t = t == null ? null : t + "";
    for (a in n) {
      if ((i = n[a]).name !== t) {
        o = !1;
        continue;
      }
      r = i.state > oi && i.state < ai, i.state = Fn, i.timer.stop(), i.on.call(r ? "interrupt" : "cancel", e, e.__data__, i.index, i.group), delete n[a];
    }
    o && delete e.__transition;
  }
}
function ss(e) {
  return this.each(function() {
    ls(this, e);
  });
}
function cs(e, t) {
  var n, i;
  return function() {
    var r = Kt(this, e), o = r.tween;
    if (o !== n) {
      i = n = o;
      for (var a = 0, s = i.length; a < s; ++a)
        if (i[a].name === t) {
          i = i.slice(), i.splice(a, 1);
          break;
        }
    }
    r.tween = i;
  };
}
function us(e, t, n) {
  var i, r;
  if (typeof n != "function") throw new Error();
  return function() {
    var o = Kt(this, e), a = o.tween;
    if (a !== i) {
      r = (i = a).slice();
      for (var s = { name: t, value: n }, l = 0, u = r.length; l < u; ++l)
        if (r[l].name === t) {
          r[l] = s;
          break;
        }
      l === u && r.push(s);
    }
    o.tween = r;
  };
}
function fs(e, t) {
  var n = this._id;
  if (e += "", arguments.length < 2) {
    for (var i = Vt(this.node(), n).tween, r = 0, o = i.length, a; r < o; ++r)
      if ((a = i[r]).name === e)
        return a.value;
    return null;
  }
  return this.each((t == null ? cs : us)(n, e, t));
}
function di(e, t, n) {
  var i = e._id;
  return e.each(function() {
    var r = Kt(this, i);
    (r.value || (r.value = {}))[t] = n.apply(this, arguments);
  }), function(r) {
    return Vt(r, i).value[t];
  };
}
function pr(e, t) {
  var n;
  return (typeof t == "number" ? ke : t instanceof Nn ? Fi : (n = Nn(t)) ? (t = n, Fi) : Kl)(e, t);
}
function ps(e) {
  return function() {
    this.removeAttribute(e);
  };
}
function ds(e) {
  return function() {
    this.removeAttributeNS(e.space, e.local);
  };
}
function ms(e, t, n) {
  var i, r = n + "", o;
  return function() {
    var a = this.getAttribute(e);
    return a === r ? null : a === i ? o : o = t(i = a, n);
  };
}
function hs(e, t, n) {
  var i, r = n + "", o;
  return function() {
    var a = this.getAttributeNS(e.space, e.local);
    return a === r ? null : a === i ? o : o = t(i = a, n);
  };
}
function gs(e, t, n) {
  var i, r, o;
  return function() {
    var a, s = n(this), l;
    return s == null ? void this.removeAttribute(e) : (a = this.getAttribute(e), l = s + "", a === l ? null : a === i && l === r ? o : (r = l, o = t(i = a, s)));
  };
}
function _s(e, t, n) {
  var i, r, o;
  return function() {
    var a, s = n(this), l;
    return s == null ? void this.removeAttributeNS(e.space, e.local) : (a = this.getAttributeNS(e.space, e.local), l = s + "", a === l ? null : a === i && l === r ? o : (r = l, o = t(i = a, s)));
  };
}
function Ps(e, t) {
  var n = Bn(e), i = n === "transform" ? jl : pr;
  return this.attrTween(e, typeof t == "function" ? (n.local ? _s : gs)(n, i, di(this, "attr." + e, t)) : t == null ? (n.local ? ds : ps)(n) : (n.local ? hs : ms)(n, i, t));
}
function xs(e, t) {
  return function(n) {
    this.setAttribute(e, t.call(this, n));
  };
}
function ws(e, t) {
  return function(n) {
    this.setAttributeNS(e.space, e.local, t.call(this, n));
  };
}
function ys(e, t) {
  var n, i;
  function r() {
    var o = t.apply(this, arguments);
    return o !== i && (n = (i = o) && ws(e, o)), n;
  }
  return r._value = t, r;
}
function Ns(e, t) {
  var n, i;
  function r() {
    var o = t.apply(this, arguments);
    return o !== i && (n = (i = o) && xs(e, o)), n;
  }
  return r._value = t, r;
}
function bs(e, t) {
  var n = "attr." + e;
  if (arguments.length < 2) return (n = this.tween(n)) && n._value;
  if (t == null) return this.tween(n, null);
  if (typeof t != "function") throw new Error();
  var i = Bn(e);
  return this.tween(n, (i.local ? ys : Ns)(i, t));
}
function vs(e, t) {
  return function() {
    pi(this, e).delay = +t.apply(this, arguments);
  };
}
function Cs(e, t) {
  return t = +t, function() {
    pi(this, e).delay = t;
  };
}
function As(e) {
  var t = this._id;
  return arguments.length ? this.each((typeof e == "function" ? vs : Cs)(t, e)) : Vt(this.node(), t).delay;
}
function Ls(e, t) {
  return function() {
    Kt(this, e).duration = +t.apply(this, arguments);
  };
}
function Is(e, t) {
  return t = +t, function() {
    Kt(this, e).duration = t;
  };
}
function Os(e) {
  var t = this._id;
  return arguments.length ? this.each((typeof e == "function" ? Ls : Is)(t, e)) : Vt(this.node(), t).duration;
}
function Ms(e, t) {
  if (typeof t != "function") throw new Error();
  return function() {
    Kt(this, e).ease = t;
  };
}
function Ss(e) {
  var t = this._id;
  return arguments.length ? this.each(Ms(t, e)) : Vt(this.node(), t).ease;
}
function Ts(e, t) {
  return function() {
    var n = t.apply(this, arguments);
    if (typeof n != "function") throw new Error();
    Kt(this, e).ease = n;
  };
}
function Ds(e) {
  if (typeof e != "function") throw new Error();
  return this.each(Ts(this._id, e));
}
function Rs(e) {
  typeof e != "function" && (e = Xi(e));
  for (var t = this._groups, n = t.length, i = new Array(n), r = 0; r < n; ++r)
    for (var o = t[r], a = o.length, s = i[r] = [], l, u = 0; u < a; ++u)
      (l = o[u]) && e.call(l, l.__data__, u, o) && s.push(l);
  return new me(i, this._parents, this._name, this._id);
}
function Fs(e) {
  if (e._id !== this._id) throw new Error();
  for (var t = this._groups, n = e._groups, i = t.length, r = n.length, o = Math.min(i, r), a = new Array(i), s = 0; s < o; ++s)
    for (var l = t[s], u = n[s], f = l.length, _ = a[s] = new Array(f), m, P = 0; P < f; ++P)
      (m = l[P] || u[P]) && (_[P] = m);
  for (; s < i; ++s)
    a[s] = t[s];
  return new me(a, this._parents, this._name, this._id);
}
function Es(e) {
  return (e + "").trim().split(/^|\s+/).every(function(t) {
    var n = t.indexOf(".");
    return n >= 0 && (t = t.slice(0, n)), !t || t === "start";
  });
}
function $s(e, t, n) {
  var i, r, o = Es(t) ? pi : Kt;
  return function() {
    var a = o(this, e), s = a.on;
    s !== i && (r = (i = s).copy()).on(t, n), a.on = r;
  };
}
function ks(e, t) {
  var n = this._id;
  return arguments.length < 2 ? Vt(this.node(), n).on.on(e) : this.each($s(n, e, t));
}
function Us(e) {
  return function() {
    var t = this.parentNode;
    for (var n in this.__transition) if (+n !== e) return;
    t && t.removeChild(this);
  };
}
function Vs() {
  return this.on("end.remove", Us(this._id));
}
function zs(e) {
  var t = this._name, n = this._id;
  typeof e != "function" && (e = si(e));
  for (var i = this._groups, r = i.length, o = new Array(r), a = 0; a < r; ++a)
    for (var s = i[a], l = s.length, u = o[a] = new Array(l), f, _, m = 0; m < l; ++m)
      (f = s[m]) && (_ = e.call(f, f.__data__, m, s)) && ("__data__" in f && (_.__data__ = f.__data__), u[m] = _, Hn(u[m], t, n, m, u, Vt(f, n)));
  return new me(o, this._parents, t, n);
}
function Bs(e) {
  var t = this._name, n = this._id;
  typeof e != "function" && (e = Gi(e));
  for (var i = this._groups, r = i.length, o = [], a = [], s = 0; s < r; ++s)
    for (var l = i[s], u = l.length, f, _ = 0; _ < u; ++_)
      if (f = l[_]) {
        for (var m = e.call(f, f.__data__, _, l), P, b = Vt(f, n), w = 0, g = m.length; w < g; ++w)
          (P = m[w]) && Hn(P, t, n, w, m, b);
        o.push(m), a.push(f);
      }
  return new me(o, a, t, n);
}
var Ws = vn.prototype.constructor;
function Hs() {
  return new Ws(this._groups, this._parents);
}
function Ys(e, t) {
  var n, i, r;
  return function() {
    var o = cn(this, e), a = (this.style.removeProperty(e), cn(this, e));
    return o === a ? null : o === n && a === i ? r : r = t(n = o, i = a);
  };
}
function dr(e) {
  return function() {
    this.style.removeProperty(e);
  };
}
function Gs(e, t, n) {
  var i, r = n + "", o;
  return function() {
    var a = cn(this, e);
    return a === r ? null : a === i ? o : o = t(i = a, n);
  };
}
function Xs(e, t, n) {
  var i, r, o;
  return function() {
    var a = cn(this, e), s = n(this), l = s + "";
    return s == null && (l = s = (this.style.removeProperty(e), cn(this, e))), a === l ? null : a === i && l === r ? o : (r = l, o = t(i = a, s));
  };
}
function qs(e, t) {
  var n, i, r, o = "style." + t, a = "end." + o, s;
  return function() {
    var l = Kt(this, e), u = l.on, f = l.value[o] == null ? s || (s = dr(t)) : void 0;
    (u !== n || r !== f) && (i = (n = u).copy()).on(a, r = f), l.on = i;
  };
}
function Ks(e, t, n) {
  var i = (e += "") == "transform" ? Ql : pr;
  return t == null ? this.styleTween(e, Ys(e, i)).on("end.style." + e, dr(e)) : typeof t == "function" ? this.styleTween(e, Xs(e, i, di(this, "style." + e, t))).each(qs(this._id, e)) : this.styleTween(e, Gs(e, i, t), n).on("end.style." + e, null);
}
function Js(e, t, n) {
  return function(i) {
    this.style.setProperty(e, t.call(this, i), n);
  };
}
function Zs(e, t, n) {
  var i, r;
  function o() {
    var a = t.apply(this, arguments);
    return a !== r && (i = (r = a) && Js(e, a, n)), i;
  }
  return o._value = t, o;
}
function Qs(e, t, n) {
  var i = "style." + (e += "");
  if (arguments.length < 2) return (i = this.tween(i)) && i._value;
  if (t == null) return this.tween(i, null);
  if (typeof t != "function") throw new Error();
  return this.tween(i, Zs(e, t, n ?? ""));
}
function js(e) {
  return function() {
    this.textContent = e;
  };
}
function tc(e) {
  return function() {
    var t = e(this);
    this.textContent = t ?? "";
  };
}
function ec(e) {
  return this.tween("text", typeof e == "function" ? tc(di(this, "text", e)) : js(e == null ? "" : e + ""));
}
function nc(e) {
  return function(t) {
    this.textContent = e.call(this, t);
  };
}
function ic(e) {
  var t, n;
  function i() {
    var r = e.apply(this, arguments);
    return r !== n && (t = (n = r) && nc(r)), t;
  }
  return i._value = e, i;
}
function rc(e) {
  var t = "text";
  if (arguments.length < 1) return (t = this.tween(t)) && t._value;
  if (e == null) return this.tween(t, null);
  if (typeof e != "function") throw new Error();
  return this.tween(t, ic(e));
}
function oc() {
  for (var e = this._name, t = this._id, n = mr(), i = this._groups, r = i.length, o = 0; o < r; ++o)
    for (var a = i[o], s = a.length, l, u = 0; u < s; ++u)
      if (l = a[u]) {
        var f = Vt(l, t);
        Hn(l, e, n, u, a, {
          time: f.time + f.delay + f.duration,
          delay: 0,
          duration: f.duration,
          ease: f.ease
        });
      }
  return new me(i, this._parents, e, n);
}
function ac() {
  var e, t, n = this, i = n._id, r = n.size();
  return new Promise(function(o, a) {
    var s = { value: a }, l = { value: function() {
      --r === 0 && o();
    } };
    n.each(function() {
      var u = Kt(this, i), f = u.on;
      f !== e && (t = (e = f).copy(), t._.cancel.push(s), t._.interrupt.push(s), t._.end.push(l)), u.on = t;
    }), r === 0 && o();
  });
}
var lc = 0;
function me(e, t, n, i) {
  this._groups = e, this._parents = t, this._name = n, this._id = i;
}
function mr() {
  return ++lc;
}
var fe = vn.prototype;
me.prototype = {
  constructor: me,
  select: zs,
  selectAll: Bs,
  selectChild: fe.selectChild,
  selectChildren: fe.selectChildren,
  filter: Rs,
  merge: Fs,
  selection: Hs,
  transition: oc,
  call: fe.call,
  nodes: fe.nodes,
  node: fe.node,
  size: fe.size,
  empty: fe.empty,
  each: fe.each,
  on: ks,
  attr: Ps,
  attrTween: bs,
  style: Ks,
  styleTween: Qs,
  text: ec,
  textTween: rc,
  remove: Vs,
  tween: fs,
  delay: As,
  duration: Os,
  ease: Ss,
  easeVarying: Ds,
  end: ac,
  [Symbol.iterator]: fe[Symbol.iterator]
};
function sc(e) {
  return ((e *= 2) <= 1 ? e * e * e : (e -= 2) * e * e + 2) / 2;
}
var cc = {
  time: null,
  // Set on use.
  delay: 0,
  duration: 250,
  ease: sc
};
function uc(e, t) {
  for (var n; !(n = e.__transition) || !(n = n[t]); )
    if (!(e = e.parentNode))
      throw new Error(`transition ${t} not found`);
  return n;
}
function fc(e) {
  var t, n;
  e instanceof me ? (t = e._id, e = e._name) : (t = mr(), (n = cc).time = fi(), e = e == null ? null : e + "");
  for (var i = this._groups, r = i.length, o = 0; o < r; ++o)
    for (var a = i[o], s = a.length, l, u = 0; u < s; ++u)
      (l = a[u]) && Hn(l, e, t, u, a, n || uc(l, t));
  return new me(i, this._parents, e, t);
}
vn.prototype.interrupt = ss;
vn.prototype.transition = fc;
function an(e, t, n) {
  this.k = e, this.x = t, this.y = n;
}
an.prototype = {
  constructor: an,
  scale: function(e) {
    return e === 1 ? this : new an(this.k * e, this.x, this.y);
  },
  translate: function(e, t) {
    return e === 0 & t === 0 ? this : new an(this.k, this.x + this.k * e, this.y + this.k * t);
  },
  apply: function(e) {
    return [e[0] * this.k + this.x, e[1] * this.k + this.y];
  },
  applyX: function(e) {
    return e * this.k + this.x;
  },
  applyY: function(e) {
    return e * this.k + this.y;
  },
  invert: function(e) {
    return [(e[0] - this.x) / this.k, (e[1] - this.y) / this.k];
  },
  invertX: function(e) {
    return (e - this.x) / this.k;
  },
  invertY: function(e) {
    return (e - this.y) / this.k;
  },
  rescaleX: function(e) {
    return e.copy().domain(e.range().map(this.invertX, this).map(e.invert, e));
  },
  rescaleY: function(e) {
    return e.copy().domain(e.range().map(this.invertY, this).map(e.invert, e));
  },
  toString: function() {
    return "translate(" + this.x + "," + this.y + ") scale(" + this.k + ")";
  }
};
var Kp = new an(1, 0, 0);
an.prototype;
const pc = {
  color: "#7579F5",
  data: [],
  title: "",
  subtitle: "",
  value: 0,
  timezone: jn.tz.guess(),
  hideYAxis: !0,
  hideXAxisLabel: !0,
  height: "57px",
  lineWidth: 1.75,
  hideCrossHair: !0,
  filledMarker: !0,
  padding: 0
};
function Jp(e) {
  const t = he(8), {
    textWidgetProps: n,
    statusTextWidgetProps: i,
    splineGraphProps: r,
    chipText: o,
    variant: a,
    outlined: s,
    loading: l
  } = e, u = a === void 0 ? "status" : a, f = s === void 0 ? !1 : s, _ = l === void 0 ? !1 : l;
  let m;
  return t[0] !== o || t[1] !== _ || t[2] !== f || t[3] !== r || t[4] !== i || t[5] !== n || t[6] !== u ? (m = _ ? /* @__PURE__ */ p(Xe, { variant: "rectangular", width: "100%", height: 100 }) : /* @__PURE__ */ O(rt, { container: !0, sx: [Ln.container, f && Ln.outlined], children: [
    /* @__PURE__ */ O(rt, { container: !0, sx: Ln.contentContainer, children: [
      u === "status" && /* @__PURE__ */ p(qo, { ...i }),
      u === "percentage" && /* @__PURE__ */ p(Ho, { ...n }),
      o && /* @__PURE__ */ p(eo, { label: o, sx: Ln.chip })
    ] }),
    /* @__PURE__ */ p(Ko, { ...pc, ...r })
  ] }), t[0] = o, t[1] = _, t[2] = f, t[3] = r, t[4] = i, t[5] = n, t[6] = u, t[7] = m) : m = t[7], m;
}
const hr = (e) => {
  const t = he(36), {
    children: n,
    style: i,
    sx: r,
    toolbar: o,
    onNodeSelect: a,
    onExpandedItemsChange: s,
    expandedItems: l,
    defaultExpandedItems: u,
    collapseIcon: f,
    expandIcon: _,
    data: m,
    renderItem: P,
    selected: b,
    itemChildrenIndentation: w,
    urlParamKey: g
  } = e, y = f === void 0 ? qr : f, k = _ === void 0 ? Oo : _, L = w === void 0 ? 20 : w, C = g === void 0 ? "menuID" : g;
  let S;
  t[0] !== C ? (S = new URLSearchParams(window.location.search).get(C), t[0] = C, t[1] = S) : S = t[1];
  const V = S;
  let q;
  t[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (q = {
    xs: 12
  }, t[2] = q) : q = t[2];
  let F;
  t[3] !== i || t[4] !== r ? (F = {
    marginTop: "0.2rem",
    padding: ".5rem",
    borderRadius: "4px",
    overflow: "auto",
    ...i,
    ...r
  }, t[3] = i, t[4] = r, t[5] = F) : F = t[5];
  let Z;
  t[6] !== n || t[7] !== m || t[8] !== u ? (Z = u ?? ["all", ...gr(n), ...m ? _r(m) : []], t[6] = n, t[7] = m, t[8] = u, t[9] = Z) : Z = t[9];
  const $ = b ?? V ?? "all";
  let X;
  t[10] !== y || t[11] !== k ? (X = {
    collapseIcon: y,
    expandIcon: k
  }, t[10] = y, t[11] = k, t[12] = X) : X = t[12];
  let K;
  t[13] !== a || t[14] !== C ? (K = (ht, ot) => {
    const Pt = ot || "all";
    C && Wi({
      [C]: Pt
    }), a && a(ht, Pt);
  }, t[13] = a, t[14] = C, t[15] = K) : K = t[15];
  let Q;
  t[16] !== m || t[17] !== P || t[18] !== C ? (Q = m && /* @__PURE__ */ p(Pr, { data: m, renderItem: P, urlParamKey: C }), t[16] = m, t[17] = P, t[18] = C, t[19] = Q) : Q = t[19];
  let T;
  t[20] !== n || t[21] !== l || t[22] !== L || t[23] !== s || t[24] !== X || t[25] !== K || t[26] !== Q || t[27] !== Z || t[28] !== $ ? (T = /* @__PURE__ */ O(Io, { defaultExpandedItems: Z, expandedItems: l, selectedItems: $, itemChildrenIndentation: L, expansionTrigger: "iconContainer", "aria-label": "product family navigator", slots: X, onExpandedItemsChange: s, onSelectedItemsChange: K, children: [
    Q,
    n
  ] }), t[20] = n, t[21] = l, t[22] = L, t[23] = s, t[24] = X, t[25] = K, t[26] = Q, t[27] = Z, t[28] = $, t[29] = T) : T = t[29];
  let H;
  t[30] !== T || t[31] !== F ? (H = /* @__PURE__ */ p(Qn, { variant: "outlined", elevation: 0, sx: F, children: T }), t[30] = T, t[31] = F, t[32] = H) : H = t[32];
  let et;
  return t[33] !== H || t[34] !== o ? (et = /* @__PURE__ */ p(rt, { container: !0, children: /* @__PURE__ */ O(rt, { size: q, children: [
    o,
    H
  ] }) }), t[33] = H, t[34] = o, t[35] = et) : et = t[35], et;
}, dc = (e) => {
  const t = he(15), {
    icon: n,
    id: i,
    label: r,
    style: o,
    sx: a,
    disabled: s,
    onClick: l,
    onContextMenu: u,
    children: f
  } = e;
  let _;
  t[0] !== l || t[1] !== u ? (_ = (b) => {
    b.preventDefault(), l(), u?.(b);
  }, t[0] = l, t[1] = u, t[2] = _) : _ = t[2];
  let m;
  t[3] !== r || t[4] !== l || t[5] !== o || t[6] !== a || t[7] !== _ ? (m = /* @__PURE__ */ p(St, { display: "flex", alignItems: "center", px: 0.75, py: 0.5, lineHeight: 1.2, style: o, sx: a, onClick: l, onContextMenu: _, children: r }), t[3] = r, t[4] = l, t[5] = o, t[6] = a, t[7] = _, t[8] = m) : m = t[8];
  let P;
  return t[9] !== f || t[10] !== s || t[11] !== n || t[12] !== i || t[13] !== m ? (P = /* @__PURE__ */ p(Mo, { itemId: i, disabled: s, icon: n, label: m, children: f }, i), t[9] = f, t[10] = s, t[11] = n, t[12] = i, t[13] = m, t[14] = P) : P = t[14], P;
};
hr.Leaf = dc;
function gr(e) {
  const t = [];
  return xn.Children.forEach(e, (n) => {
    if (xn.isValidElement(n)) {
      const i = n.props, r = i.itemId ?? i.id;
      r && t.push(r), i.children && t.push(...gr(i.children));
    }
  }), t;
}
function _r(e) {
  const t = [];
  return e.forEach((n) => {
    t.push(n.id), n.children && t.push(..._r(n.children));
  }), t;
}
function Pr({
  data: e,
  renderItem: t,
  urlParamKey: n
}) {
  return e ? e.map((i) => /* @__PURE__ */ p(hr.Leaf, { id: i.id, disabled: i.disabled, label: t?.(i) ?? i.label, icon: i.icon, onClick: () => {
    n && Wi({
      [n]: i.id
    });
  }, children: i.children && /* @__PURE__ */ p(Pr, { data: i.children, renderItem: t, urlParamKey: n }) }, i.id)) : null;
}
class Zp extends xn.Component {
  constructor(t) {
    super(t), this.state = {
      hasError: !1
    };
  }
  static getDerivedStateFromError(t) {
    return {
      hasError: !0,
      error: t
    };
  }
  componentDidCatch(t, n) {
    console.log("render failed", t, n);
  }
  render() {
    if (this.state.hasError) {
      const {
        errorImageSrc: t = "images/wentWrong.png",
        homeHref: n = "/"
      } = this.props;
      return /* @__PURE__ */ O("div", { style: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh"
      }, children: [
        t ? /* @__PURE__ */ p("img", { src: t, alt: "error" }) : null,
        /* @__PURE__ */ p(Ct, { variant: "h4", children: "Something went wrong." }),
        /* @__PURE__ */ p("br", {}),
        /* @__PURE__ */ p(Tr, { severity: "error", children: this.state.error?.message ?? "Unknown error" }),
        /* @__PURE__ */ p(Ct, { variant: "caption", children: "Check developer console for more details." }),
        /* @__PURE__ */ p("br", {}),
        /* @__PURE__ */ p(no, { variant: "contained", color: "primary", onClick: () => {
          window.location.href = n;
        }, children: "Go Back to Home" })
      ] });
    }
    return this.props.children;
  }
}
const mc = (e) => {
  const t = he(51), {
    open: n,
    onClose: i,
    planInfo: r,
    customPlanName: o,
    onCustomPlanNameChange: a,
    onCustomPlanNameBlur: s,
    onFileSelect: l,
    onSubmit: u
  } = e, f = r.planType === "Custom";
  let _;
  t[0] !== r.dialogTitle || t[1] !== r.icon ? (_ = /* @__PURE__ */ O(Dr, { sx: mn.uploadDialog.title, children: [
    r.icon,
    r.dialogTitle
  ] }), t[0] = r.dialogTitle, t[1] = r.icon, t[2] = _) : _ = t[2];
  let m;
  if (t[3] !== r.planType) {
    let H;
    t[5] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (H = /\s+/g, t[5] = H) : H = t[5], m = r.planType.toLowerCase().replace(H, "-"), t[3] = r.planType, t[4] = m;
  } else
    m = t[4];
  const P = `${m}-plan-upload`;
  let b;
  t[6] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (b = {
    width: "fit-content"
  }, t[6] = b) : b = t[6];
  let w;
  t[7] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (w = /* @__PURE__ */ p(Kn, { variant: "outlined", component: "span", startIcon: /* @__PURE__ */ p(zr, {}), sx: {
    width: "100%"
  }, children: "Upload Image" }), t[7] = w) : w = t[7];
  let g;
  if (t[8] !== r.planType) {
    let H;
    t[10] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (H = /\s+/g, t[10] = H) : H = t[10], g = r.planType.toLowerCase().replace(H, "-"), t[8] = r.planType, t[9] = g;
  } else
    g = t[9];
  const y = `${g}-plan-upload`, k = `Upload ${r.planType} Plan Image`;
  let L;
  t[11] !== l || t[12] !== y || t[13] !== k ? (L = /* @__PURE__ */ p("input", { id: y, type: "file", hidden: !0, accept: "image/*", onChange: l, "aria-label": k }), t[11] = l, t[12] = y, t[13] = k, t[14] = L) : L = t[14];
  let C;
  t[15] !== P || t[16] !== L ? (C = /* @__PURE__ */ O("label", { htmlFor: P, style: b, children: [
    w,
    L
  ] }), t[15] = P, t[16] = L, t[17] = C) : C = t[17];
  let S;
  t[18] !== o || t[19] !== f || t[20] !== s || t[21] !== a || t[22] !== r.validation ? (S = f && /* @__PURE__ */ p(St, { sx: {
    mt: 2
  }, children: /* @__PURE__ */ p(Eo, { label: "Plan Name", value: o || "", onChange: (H) => a(H.target.value.slice(0, 40)), onBlur: s, placeholder: "Enter custom plan name", error: r.validation.showError, errorText: r.validation.showError ? r.validation.customPlanNameError : void 0, inputProps: {
    maxLength: 40
  }, height: 40 }) }), t[18] = o, t[19] = f, t[20] = s, t[21] = a, t[22] = r.validation, t[23] = S) : S = t[23];
  let V;
  t[24] !== r.currentFileData || t[25] !== r.displayImageName || t[26] !== r.displayPreviewUrl || t[27] !== r.planType ? (V = r.displayPreviewUrl && /* @__PURE__ */ O(sn, { children: [
    /* @__PURE__ */ p(St, { sx: mn.uploadDialog.imagePreview, children: /* @__PURE__ */ p("img", { src: r.displayPreviewUrl, alt: `${r.planType} Plan Preview`, style: mn.uploadDialog.previewImage }) }),
    r.displayImageName && /* @__PURE__ */ p(wt, { title: r.currentFileData.previewUrl && r.currentFileData.imageSize > 0 ? `${r.displayImageName} (${_i(r.currentFileData.imageSize)})` : r.displayImageName, children: /* @__PURE__ */ O(Sn, { sx: mn.uploadDialog.fileInfo, children: [
      r.displayImageName,
      r.currentFileData.previewUrl && r.currentFileData.imageSize > 0 ? ` - ${_i(r.currentFileData.imageSize)}` : ""
    ] }) })
  ] }), t[24] = r.currentFileData, t[25] = r.displayImageName, t[26] = r.displayPreviewUrl, t[27] = r.planType, t[28] = V) : V = t[28];
  let q;
  t[29] !== C || t[30] !== S || t[31] !== V ? (q = /* @__PURE__ */ p(Rr, { children: /* @__PURE__ */ O(St, { sx: mn.uploadDialog.content, children: [
    C,
    S,
    V
  ] }) }), t[29] = C, t[30] = S, t[31] = V, t[32] = q) : q = t[32];
  let F;
  t[33] !== i ? (F = /* @__PURE__ */ p(Kn, { onClick: i, children: "Cancel" }), t[33] = i, t[34] = F) : F = t[34];
  const Z = f && !r.validation.isValid ? r.validation.customPlanNameError || "Please provide a valid plan name" : r.shouldDisableSubmit && !r.currentFileData.previewUrl ? "Please select an image to upload" : "", $ = f && r.hasExistingData ? "Save" : "Upload";
  let X;
  t[35] !== u || t[36] !== r.shouldDisableSubmit || t[37] !== $ ? (X = /* @__PURE__ */ p("span", { children: /* @__PURE__ */ p(Kn, { onClick: u, variant: "contained", disabled: r.shouldDisableSubmit, children: $ }) }), t[35] = u, t[36] = r.shouldDisableSubmit, t[37] = $, t[38] = X) : X = t[38];
  let K;
  t[39] !== Z || t[40] !== X ? (K = /* @__PURE__ */ p(wt, { title: Z, arrow: !0, children: X }), t[39] = Z, t[40] = X, t[41] = K) : K = t[41];
  let Q;
  t[42] !== F || t[43] !== K ? (Q = /* @__PURE__ */ O(Fr, { children: [
    F,
    K
  ] }), t[42] = F, t[43] = K, t[44] = Q) : Q = t[44];
  let T;
  return t[45] !== i || t[46] !== n || t[47] !== _ || t[48] !== q || t[49] !== Q ? (T = /* @__PURE__ */ O(Er, { open: n, onClose: i, maxWidth: "sm", fullWidth: !0, children: [
    _,
    q,
    Q
  ] }), t[45] = i, t[46] = n, t[47] = _, t[48] = q, t[49] = Q, t[50] = T) : T = t[50], T;
}, hc = (e) => {
  const t = he(257), {
    overlays: n,
    isFullscreen: i,
    overlayOpacity: r,
    onResetOverlay: o,
    onOpacityChange: a,
    onFullscreenToggle: s,
    onViewModeChange: l,
    onUpload: u,
    onPlanDelete: f,
    onSelectCustomPlan: _,
    onAddCustomPlan: m,
    onMapTypeChange: P,
    currentMapType: b
  } = e, w = $r(), g = n[0], [y, k] = xn.useState(!1), L = !!g?.plan?.calibrationPoints?.floorPlan?.imageData, C = !!g?.plan?.calibrationPoints?.rfPlan?.imageData, S = !!g?.plan?.calibrationPoints?.sinrPlan?.imageData, V = !!g?.plan?.calibrationPoints?.dominantCellPlan?.imageData;
  let q;
  t[0] !== g?.plan?.calibrationPoints?.customPlan ? (q = g?.plan?.calibrationPoints?.customPlan || [], t[0] = g?.plan?.calibrationPoints?.customPlan, t[1] = q) : q = t[1];
  const F = q;
  let Z;
  t[2] !== g?.currentViewMode ? (Z = (st) => g?.currentViewMode === st, t[2] = g?.currentViewMode, t[3] = Z) : Z = t[3];
  const $ = Z, [X, K] = xn.useState(null), Q = !!X, T = g?.selectedCustomPlanName || F[0]?.planName;
  let H;
  if (t[4] !== F || t[5] !== T) {
    let st;
    t[7] !== T ? (st = (pn) => pn.planName === T, t[7] = T, t[8] = st) : st = t[8], H = F.find(st), t[4] = F, t[5] = T, t[6] = H;
  } else
    H = t[6];
  const et = H;
  let ht;
  t[9] !== g?.currentViewMode || t[10] !== g?.plan?.calibrationPoints?.dominantCellPlan?.imageName || t[11] !== g?.plan?.calibrationPoints?.floorPlan?.imageName || t[12] !== g?.plan?.calibrationPoints?.rfPlan?.imageName || t[13] !== g?.plan?.calibrationPoints?.sinrPlan?.imageName || t[14] !== et?.imagesInfo?.imageName || t[15] !== T ? (ht = () => {
    switch (g?.currentViewMode) {
      case "FLOOR_PLAN":
        return g?.plan?.calibrationPoints?.floorPlan?.imageName;
      case "RF_PLAN":
        return g?.plan?.calibrationPoints?.rfPlan?.imageName;
      case "SINR_PLAN":
        return g?.plan?.calibrationPoints?.sinrPlan?.imageName;
      case "DOMINANT_CELL_PLAN":
        return g?.plan?.calibrationPoints?.dominantCellPlan?.imageName;
      case "CUSTOM_PLAN":
        return et?.imagesInfo?.imageName || T;
      default:
        return;
    }
  }, t[9] = g?.currentViewMode, t[10] = g?.plan?.calibrationPoints?.dominantCellPlan?.imageName, t[11] = g?.plan?.calibrationPoints?.floorPlan?.imageName, t[12] = g?.plan?.calibrationPoints?.rfPlan?.imageName, t[13] = g?.plan?.calibrationPoints?.sinrPlan?.imageName, t[14] = et?.imagesInfo?.imageName, t[15] = T, t[16] = ht) : ht = t[16];
  const ot = ht;
  let Pt;
  t[17] !== g?.currentViewMode || t[18] !== g?.plan?.calibrationPoints?.dominantCellPlan?.imageData || t[19] !== g?.plan?.calibrationPoints?.floorPlan?.imageData || t[20] !== g?.plan?.calibrationPoints?.rfPlan?.imageData || t[21] !== g?.plan?.calibrationPoints?.sinrPlan?.imageData || t[22] !== et?.imagesInfo?.imageData ? (Pt = () => {
    switch (g?.currentViewMode) {
      case "FLOOR_PLAN":
        return g?.plan?.calibrationPoints?.floorPlan?.imageData;
      case "RF_PLAN":
        return g?.plan?.calibrationPoints?.rfPlan?.imageData;
      case "SINR_PLAN":
        return g?.plan?.calibrationPoints?.sinrPlan?.imageData;
      case "DOMINANT_CELL_PLAN":
        return g?.plan?.calibrationPoints?.dominantCellPlan?.imageData;
      case "CUSTOM_PLAN":
        return et?.imagesInfo?.imageData;
      default:
        return;
    }
  }, t[17] = g?.currentViewMode, t[18] = g?.plan?.calibrationPoints?.dominantCellPlan?.imageData, t[19] = g?.plan?.calibrationPoints?.floorPlan?.imageData, t[20] = g?.plan?.calibrationPoints?.rfPlan?.imageData, t[21] = g?.plan?.calibrationPoints?.sinrPlan?.imageData, t[22] = et?.imagesInfo?.imageData, t[23] = Pt) : Pt = t[23];
  const Ue = Pt;
  let ge;
  t[24] !== Ue || t[25] !== ot ? (ge = () => {
    const st = ot(), pn = Ue();
    Co(pn, st);
  }, t[24] = Ue, t[25] = ot, t[26] = ge) : ge = t[26];
  const G = ge;
  let ft;
  t[27] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (ft = {
    mr: 1,
    height: "24px",
    fontSize: "12px"
  }, t[27] = ft) : ft = t[27];
  let zt;
  t[28] !== P ? (zt = () => P?.("ROADMAP"), t[28] = P, t[29] = zt) : zt = t[29];
  let _e;
  t[30] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (_e = /* @__PURE__ */ p(bo, { fontSize: "small" }), t[30] = _e) : _e = t[30];
  let Jt;
  t[31] !== zt ? (Jt = /* @__PURE__ */ p(wt, { title: "Roadmap", children: /* @__PURE__ */ p(Xt, { value: "ROADMAP", onClick: zt, children: _e }) }), t[31] = zt, t[32] = Jt) : Jt = t[32];
  let Pe;
  t[33] !== P ? (Pe = () => P?.("HYBRID"), t[33] = P, t[34] = Pe) : Pe = t[34];
  let xe;
  t[35] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (xe = /* @__PURE__ */ p(vo, { fontSize: "small" }), t[35] = xe) : xe = t[35];
  let nt;
  t[36] !== Pe ? (nt = /* @__PURE__ */ p(wt, { title: "Satellite", children: /* @__PURE__ */ p(Xt, { value: "HYBRID", onClick: Pe, children: xe }) }), t[36] = Pe, t[37] = nt) : nt = t[37];
  let we;
  t[38] !== b || t[39] !== Jt || t[40] !== nt ? (we = /* @__PURE__ */ O(hi, { size: "small", exclusive: !0, sx: ft, value: b, color: "primary", children: [
    Jt,
    nt
  ] }), t[38] = b, t[39] = Jt, t[40] = nt, t[41] = we) : we = t[41];
  const ct = g?.currentViewMode || null;
  let yt;
  t[42] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (yt = {
    flexWrap: "wrap",
    justifyContent: "flex-start"
  }, t[42] = yt) : yt = t[42];
  let I;
  t[43] !== y || t[44] !== g?.currentViewMode || t[45] !== T || t[46] !== w ? (I = y && /* @__PURE__ */ p(Xt, { value: "TOGGLE_PLAN_TOGGLES_AC", sx: {
    ...U.planButton,
    ...U.planButtonActive(w)
  }, onClick: () => k(gc), children: /* @__PURE__ */ p(wt, { title: `Current View: ${g?.currentViewMode === "CUSTOM_PLAN" ? T ?? "Custom Plan" : Bi()[g?.currentViewMode || "FLOOR_PLAN"].tooltip}`, children: Ao(g?.currentViewMode || "FLOOR_PLAN", {
    mr: 0.5
  }, {
    fontSize: "small"
  }) }) }), t[43] = y, t[44] = g?.currentViewMode, t[45] = T, t[46] = w, t[47] = I) : I = t[47];
  let tt;
  t[48] !== y ? (tt = y && {
    display: "none"
  }, t[48] = y, t[49] = tt) : tt = t[49];
  let pt;
  t[50] !== L || t[51] !== $ || t[52] !== w ? (pt = L && $("FLOOR_PLAN") ? U.planButtonActive(w) : L ? U.planButtonInactive(w) : {}, t[50] = L, t[51] = $, t[52] = w, t[53] = pt) : pt = t[53];
  let dt;
  t[54] !== tt || t[55] !== pt ? (dt = {
    ...U.planButton,
    ...tt,
    ...pt
  }, t[54] = tt, t[55] = pt, t[56] = dt) : dt = t[56];
  let Zt;
  t[57] !== L || t[58] !== u || t[59] !== l ? (Zt = () => L ? l("FLOOR_PLAN") : u("FLOOR_PLAN"), t[57] = L, t[58] = u, t[59] = l, t[60] = Zt) : Zt = t[60];
  let Qt;
  t[61] !== L ? (Qt = L ? /* @__PURE__ */ p(yi, { fontSize: "small", sx: {
    mr: 0.5
  } }) : /* @__PURE__ */ p(on, { fontSize: "small", sx: {
    mr: 0.5
  } }), t[61] = L, t[62] = Qt) : Qt = t[62];
  let Je;
  t[63] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (Je = /* @__PURE__ */ p("span", { style: U.buttonLabel, children: "Floor Plan" }), t[63] = Je) : Je = t[63];
  let ye;
  t[64] !== dt || t[65] !== Zt || t[66] !== Qt ? (ye = /* @__PURE__ */ O(Xt, { value: "FLOOR_PLAN", sx: dt, onClick: Zt, children: [
    Qt,
    Je
  ] }), t[64] = dt, t[65] = Zt, t[66] = Qt, t[67] = ye) : ye = t[67];
  let Nt;
  t[68] !== y ? (Nt = y && {
    display: "none"
  }, t[68] = y, t[69] = Nt) : Nt = t[69];
  let It;
  t[70] !== C || t[71] !== $ || t[72] !== w ? (It = C && $("RF_PLAN") ? U.planButtonActive(w) : C ? U.planButtonInactive(w) : {}, t[70] = C, t[71] = $, t[72] = w, t[73] = It) : It = t[73];
  let jt;
  t[74] !== Nt || t[75] !== It ? (jt = {
    ...U.planButton,
    ...Nt,
    ...It
  }, t[74] = Nt, t[75] = It, t[76] = jt) : jt = t[76];
  let Ne;
  t[77] !== C || t[78] !== u || t[79] !== l ? (Ne = () => C ? l("RF_PLAN") : u("RF_PLAN"), t[77] = C, t[78] = u, t[79] = l, t[80] = Ne) : Ne = t[80];
  let be;
  t[81] !== C ? (be = C ? /* @__PURE__ */ p(go, { fontSize: "small", sx: {
    mr: 0.5
  } }) : /* @__PURE__ */ p(on, { fontSize: "small", sx: {
    mr: 0.5
  } }), t[81] = C, t[82] = be) : be = t[82];
  let ve;
  t[83] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (ve = /* @__PURE__ */ p("span", { style: U.buttonLabel, children: "RF" }), t[83] = ve) : ve = t[83];
  let te;
  t[84] !== jt || t[85] !== Ne || t[86] !== be ? (te = /* @__PURE__ */ O(Xt, { value: "RF_PLAN", sx: jt, onClick: Ne, children: [
    be,
    ve
  ] }), t[84] = jt, t[85] = Ne, t[86] = be, t[87] = te) : te = t[87];
  let ee;
  t[88] !== y ? (ee = y && {
    display: "none"
  }, t[88] = y, t[89] = ee) : ee = t[89];
  let Ce;
  t[90] !== S || t[91] !== $ || t[92] !== w ? (Ce = S && $("SINR_PLAN") ? U.planButtonActive(w) : S ? U.planButtonInactive(w) : {}, t[90] = S, t[91] = $, t[92] = w, t[93] = Ce) : Ce = t[93];
  let Tt;
  t[94] !== ee || t[95] !== Ce ? (Tt = {
    ...U.planButton,
    ...ee,
    ...Ce
  }, t[94] = ee, t[95] = Ce, t[96] = Tt) : Tt = t[96];
  let at;
  t[97] !== S || t[98] !== u || t[99] !== l ? (at = () => S ? l("SINR_PLAN") : u("SINR_PLAN"), t[97] = S, t[98] = u, t[99] = l, t[100] = at) : at = t[100];
  let Bt;
  t[101] !== S ? (Bt = S ? /* @__PURE__ */ p(_o, { fontSize: "small", sx: {
    mr: 0.5
  } }) : /* @__PURE__ */ p(on, { fontSize: "small", sx: {
    mr: 0.5
  } }), t[101] = S, t[102] = Bt) : Bt = t[102];
  let ne;
  t[103] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (ne = /* @__PURE__ */ p("span", { style: U.buttonLabel, children: "SINR" }), t[103] = ne) : ne = t[103];
  let Wt;
  t[104] !== Tt || t[105] !== at || t[106] !== Bt ? (Wt = /* @__PURE__ */ O(Xt, { value: "SINR_PLAN", sx: Tt, onClick: at, children: [
    Bt,
    ne
  ] }), t[104] = Tt, t[105] = at, t[106] = Bt, t[107] = Wt) : Wt = t[107];
  let ie;
  t[108] !== y ? (ie = y && {
    display: "none"
  }, t[108] = y, t[109] = ie) : ie = t[109];
  let Ht;
  t[110] !== V || t[111] !== $ || t[112] !== w ? (Ht = V && $("DOMINANT_CELL_PLAN") ? U.planButtonActive(w) : V ? U.planButtonInactive(w) : {}, t[110] = V, t[111] = $, t[112] = w, t[113] = Ht) : Ht = t[113];
  let Ot;
  t[114] !== ie || t[115] !== Ht ? (Ot = {
    ...U.planButton,
    ...ie,
    ...Ht
  }, t[114] = ie, t[115] = Ht, t[116] = Ot) : Ot = t[116];
  let re;
  t[117] !== V || t[118] !== u || t[119] !== l ? (re = () => V ? l("DOMINANT_CELL_PLAN") : u("DOMINANT_CELL_PLAN"), t[117] = V, t[118] = u, t[119] = l, t[120] = re) : re = t[120];
  let Dt;
  t[121] !== V ? (Dt = V ? /* @__PURE__ */ p(Po, { fontSize: "small", sx: {
    mr: 0.5
  } }) : /* @__PURE__ */ p(on, { fontSize: "small", sx: {
    mr: 0.5
  } }), t[121] = V, t[122] = Dt) : Dt = t[122];
  let Ve;
  t[123] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (Ve = /* @__PURE__ */ p("span", { style: U.buttonLabel, children: "Dominant Cell" }), t[123] = Ve) : Ve = t[123];
  let bt;
  t[124] !== Ot || t[125] !== re || t[126] !== Dt ? (bt = /* @__PURE__ */ O(Xt, { value: "DOMINANT_CELL_PLAN", sx: Ot, onClick: re, children: [
    Dt,
    Ve
  ] }), t[124] = Ot, t[125] = re, t[126] = Dt, t[127] = bt) : bt = t[127];
  let Yt;
  t[128] !== y ? (Yt = y && {
    display: "none"
  }, t[128] = y, t[129] = Yt) : Yt = t[129];
  let vt;
  t[130] !== F.length || t[131] !== g?.currentViewMode || t[132] !== w ? (vt = g?.currentViewMode === "CUSTOM_PLAN" ? U.planButtonActive(w) : F.length > 0 ? U.planButtonInactive(w) : {}, t[130] = F.length, t[131] = g?.currentViewMode, t[132] = w, t[133] = vt) : vt = t[133];
  let oe;
  t[134] !== Yt || t[135] !== vt ? (oe = {
    ...U.planButton,
    ...Yt,
    ...vt
  }, t[134] = Yt, t[135] = vt, t[136] = oe) : oe = t[136];
  let ae;
  t[137] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (ae = (st) => K(st.currentTarget), t[137] = ae) : ae = t[137];
  let Rt, Ft;
  t[138] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (Rt = /* @__PURE__ */ p(yi, { fontSize: "small", sx: {
    mr: 0.5,
    transform: "rotate(90deg)"
  } }), Ft = {
    ...U.buttonLabel
  }, t[138] = Rt, t[139] = Ft) : (Rt = t[138], Ft = t[139]);
  let D;
  t[140] !== g?.currentViewMode || t[141] !== T ? (D = g?.currentViewMode === "CUSTOM_PLAN" && T ? T.trim().slice(0, 12) + (T.length > 12 ? "..." : "") : "Custom Plan", t[140] = g?.currentViewMode, t[141] = T, t[142] = D) : D = t[142];
  let gt;
  t[143] !== D ? (gt = /* @__PURE__ */ p("span", { style: Ft, children: D }), t[143] = D, t[144] = gt) : gt = t[144];
  let ze;
  t[145] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (ze = /* @__PURE__ */ p(zi, { fontSize: "small", sx: {
    ml: 0.25
  } }), t[145] = ze) : ze = t[145];
  let Ae;
  t[146] !== oe || t[147] !== gt ? (Ae = /* @__PURE__ */ O(Xt, { value: "CUSTOM_PLAN", sx: oe, onClick: ae, children: [
    Rt,
    gt,
    ze
  ] }), t[146] = oe, t[147] = gt, t[148] = Ae) : Ae = t[148];
  let ut;
  t[149] !== y ? (ut = y && {
    display: "none"
  }, t[149] = y, t[150] = ut) : ut = t[150];
  let it;
  t[151] !== ut ? (it = {
    ...U.planButton,
    ...ut,
    minWidth: "auto"
  }, t[151] = ut, t[152] = it) : it = t[152];
  let le;
  t[153] !== m ? (le = () => m?.(), t[153] = m, t[154] = le) : le = t[154];
  let Le;
  t[155] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (Le = /* @__PURE__ */ p(wt, { title: "Add Custom Plan", children: /* @__PURE__ */ p(on, { fontSize: "small" }) }), t[155] = Le) : Le = t[155];
  let Ie;
  t[156] !== it || t[157] !== le ? (Ie = /* @__PURE__ */ p(Xt, { value: "ADD_CUSTOM_PLAN_SHORTCUT", sx: it, onClick: le, children: Le }), t[156] = it, t[157] = le, t[158] = Ie) : Ie = t[158];
  let Ze, se;
  t[159] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (Ze = {
    ...U.planButton,
    minWidth: "auto"
  }, se = () => k(_c), t[159] = Ze, t[160] = se) : (Ze = t[159], se = t[160]);
  const fn = y ? "Expand plan toggles" : "Collapse plan toggles";
  let Oe;
  t[161] !== y ? (Oe = y ? /* @__PURE__ */ p(Br, { fontSize: "small" }) : /* @__PURE__ */ p(Wr, { fontSize: "small" }), t[161] = y, t[162] = Oe) : Oe = t[162];
  let Me;
  t[163] !== fn || t[164] !== Oe ? (Me = /* @__PURE__ */ p(Xt, { value: "TOGGLE_PLAN_TOGGLES", sx: Ze, onClick: se, children: /* @__PURE__ */ p(wt, { title: fn, children: Oe }) }), t[163] = fn, t[164] = Oe, t[165] = Me) : Me = t[165];
  let Se;
  t[166] !== ct || t[167] !== I || t[168] !== ye || t[169] !== te || t[170] !== Wt || t[171] !== bt || t[172] !== Ae || t[173] !== Ie || t[174] !== Me ? (Se = /* @__PURE__ */ O(hi, { color: "primary", exclusive: !0, size: "small", value: ct, sx: yt, "aria-label": "overlay view", children: [
    I,
    ye,
    te,
    Wt,
    bt,
    Ae,
    Ie,
    Me
  ] }), t[166] = ct, t[167] = I, t[168] = ye, t[169] = te, t[170] = Wt, t[171] = bt, t[172] = Ae, t[173] = Ie, t[174] = Me, t[175] = Se) : Se = t[175];
  let Et, Qe, je, tn;
  t[176] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (Et = () => K(null), Qe = {
    dense: !0
  }, je = {
    sx: {
      maxWidth: 320,
      width: "auto"
    }
  }, tn = {
    mt: 0.5,
    maxHeight: 700,
    overflowY: "auto"
  }, t[176] = Et, t[177] = Qe, t[178] = je, t[179] = tn) : (Et = t[176], Qe = t[177], je = t[178], tn = t[179]);
  let Te;
  t[180] !== F || t[181] !== _ || t[182] !== l || t[183] !== g?.currentViewMode || t[184] !== T ? (Te = F.length > 0 ? F.map((st) => /* @__PURE__ */ p(mi, { onClick: () => {
    _?.(st.planName), l("CUSTOM_PLAN"), K(null);
  }, "aria-label": st.planName, selected: g?.currentViewMode === "CUSTOM_PLAN" && st.planName === T, disabled: g?.currentViewMode === "CUSTOM_PLAN" && st.planName === T, children: /* @__PURE__ */ p(wt, { title: st.planName, placement: "right", children: /* @__PURE__ */ p(Sn, { variant: "body2", noWrap: !0, sx: {
    maxWidth: 200,
    overflow: "hidden",
    textOverflow: "ellipsis"
  }, children: st.planName }) }) }, st.planName)) : null, t[180] = F, t[181] = _, t[182] = l, t[183] = g?.currentViewMode, t[184] = T, t[185] = Te) : Te = t[185];
  let De;
  t[186] !== m ? (De = () => {
    K(null), m?.();
  }, t[186] = m, t[187] = De) : De = t[187];
  let Be;
  t[188] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (Be = /* @__PURE__ */ p(on, { fontSize: "small", sx: {
    mr: 0.5
  } }), t[188] = Be) : Be = t[188];
  let en;
  t[189] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (en = /* @__PURE__ */ p(Sn, { variant: "body2", sx: {
    fontWeight: 500
  }, children: "Add Custom Plan" }), t[189] = en) : en = t[189];
  let Re;
  t[190] !== De ? (Re = /* @__PURE__ */ O(mi, { onClick: De, children: [
    Be,
    en
  ] }), t[190] = De, t[191] = Re) : Re = t[191];
  let Fe;
  t[192] !== X || t[193] !== Q || t[194] !== Te || t[195] !== Re ? (Fe = /* @__PURE__ */ O(kr, { anchorEl: X, open: Q, onClose: Et, MenuListProps: Qe, PaperProps: je, sx: tn, children: [
    Te,
    Re
  ] }), t[192] = X, t[193] = Q, t[194] = Te, t[195] = Re, t[196] = Fe) : Fe = t[196];
  let Mt;
  t[197] !== we || t[198] !== Se || t[199] !== Fe ? (Mt = /* @__PURE__ */ O(St, { sx: U.menuColumn, children: [
    we,
    Se,
    Fe
  ] }), t[197] = we, t[198] = Se, t[199] = Fe, t[200] = Mt) : Mt = t[200];
  let ce;
  t[201] !== o || t[202] !== g || t[203] !== n.length ? (ce = n.length > 0 && /* @__PURE__ */ p(wt, { title: "Reset Overlay", children: /* @__PURE__ */ p(pe, { onClick: () => g?.id && o(g.id), size: "small", children: /* @__PURE__ */ p(io, { fontSize: "small" }) }) }), t[201] = o, t[202] = g, t[203] = n.length, t[204] = ce) : ce = t[204];
  let nn;
  t[205] !== r ? (nn = Math.round(r * 100), t[205] = r, t[206] = nn) : nn = t[206];
  const c = `Increase Opacity (${nn}%)`;
  let d;
  t[207] !== a || t[208] !== r ? (d = () => a(Math.min(1, r + 0.1)), t[207] = a, t[208] = r, t[209] = d) : d = t[209];
  const h = r >= 1;
  let x;
  t[210] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (x = /* @__PURE__ */ p(wi, { fontSize: "small", sx: {
    transform: "rotate(180deg)"
  } }), t[210] = x) : x = t[210];
  let v;
  t[211] !== d || t[212] !== h ? (v = /* @__PURE__ */ p(pe, { onClick: d, size: "small", disabled: h, children: x }), t[211] = d, t[212] = h, t[213] = v) : v = t[213];
  let A;
  t[214] !== c || t[215] !== v ? (A = /* @__PURE__ */ p(wt, { title: c, children: v }), t[214] = c, t[215] = v, t[216] = A) : A = t[216];
  let N;
  t[217] !== r ? (N = Math.round(r * 100), t[217] = r, t[218] = N) : N = t[218];
  const E = `Decrease Opacity (${N}%)`;
  let Y;
  t[219] !== a || t[220] !== r ? (Y = () => a(Math.max(0, r - 0.1)), t[219] = a, t[220] = r, t[221] = Y) : Y = t[221];
  const B = r <= 0;
  let J;
  t[222] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (J = /* @__PURE__ */ p(wi, { fontSize: "small" }), t[222] = J) : J = t[222];
  let lt;
  t[223] !== Y || t[224] !== B ? (lt = /* @__PURE__ */ p(pe, { onClick: Y, size: "small", disabled: B, children: J }), t[223] = Y, t[224] = B, t[225] = lt) : lt = t[225];
  let R;
  t[226] !== E || t[227] !== lt ? (R = /* @__PURE__ */ p(wt, { title: E, children: lt }), t[226] = E, t[227] = lt, t[228] = R) : R = t[228];
  const W = i ? "error" : "primary";
  let z;
  t[229] !== i ? (z = i ? /* @__PURE__ */ p(co, { fontSize: "small" }) : /* @__PURE__ */ p(so, { fontSize: "small" }), t[229] = i, t[230] = z) : z = t[230];
  let M;
  t[231] !== s || t[232] !== W || t[233] !== z ? (M = /* @__PURE__ */ p(wt, { title: "Toggle Fullscreen", children: /* @__PURE__ */ p(pe, { onClick: s, size: "small", color: W, children: z }) }), t[231] = s, t[232] = W, t[233] = z, t[234] = M) : M = t[234];
  let mt;
  t[235] !== ce || t[236] !== A || t[237] !== R || t[238] !== M ? (mt = /* @__PURE__ */ O(St, { sx: U.controlsColumn, children: [
    ce,
    A,
    R,
    M
  ] }), t[235] = ce, t[236] = A, t[237] = R, t[238] = M, t[239] = mt) : mt = t[239];
  let j;
  t[240] !== Mt || t[241] !== mt ? (j = /* @__PURE__ */ p(St, { sx: U.container, children: /* @__PURE__ */ O(Qn, { elevation: 2, sx: U.paper, children: [
    Mt,
    mt
  ] }) }), t[240] = Mt, t[241] = mt, t[242] = j) : j = t[242];
  let $t;
  t[243] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? ($t = [U.container, U.planInfoContainer], t[243] = $t) : $t = t[243];
  let At;
  t[244] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (At = [U.paper, U.planPaper], t[244] = At) : At = t[244];
  let We;
  t[245] !== ot || t[246] !== G || t[247] !== f || t[248] !== u || t[249] !== g || t[250] !== T ? (We = ot() && /* @__PURE__ */ p(St, { sx: {
    display: "flex",
    justifyContent: "flex-end",
    mt: 1
  }, children: /* @__PURE__ */ O(St, { sx: U.planInfoRow, children: [
    /* @__PURE__ */ O(Sn, { variant: "body2", sx: U.fileName, title: ot(), children: [
      /* @__PURE__ */ p("strong", { children: "Image:" }),
      " ",
      ot()
    ] }),
    g?.currentViewMode === "CUSTOM_PLAN" ? /* @__PURE__ */ p(wt, { title: `Edit ${T || "Custom Plan"}`, children: /* @__PURE__ */ p(pe, { size: "small", onClick: () => u("CUSTOM_PLAN"), children: /* @__PURE__ */ p(xo, { fontSize: "small" }) }) }) : /* @__PURE__ */ p(wt, { title: `Reupload ${g?.currentViewMode === "FLOOR_PLAN" ? "Floor Plan" : g?.currentViewMode === "RF_PLAN" ? "RF Plan" : g?.currentViewMode === "SINR_PLAN" ? "SINR Plan" : "Dominant Cell Plan"}`, children: /* @__PURE__ */ p(pe, { size: "small", onClick: () => u(g?.currentViewMode || "RF_PLAN"), children: /* @__PURE__ */ p(yo, { fontSize: "small" }) }) }),
    /* @__PURE__ */ p(wt, { title: "Download image", children: /* @__PURE__ */ p(pe, { size: "small", onClick: G, children: /* @__PURE__ */ p(No, { fontSize: "small" }) }) }),
    /* @__PURE__ */ p(wt, { title: "Delete image", children: /* @__PURE__ */ p(pe, { size: "small", onClick: () => g?.currentViewMode && f?.(g.currentViewMode), children: /* @__PURE__ */ p(wo, { fontSize: "small" }) }) })
  ] }) }), t[245] = ot, t[246] = G, t[247] = f, t[248] = u, t[249] = g, t[250] = T, t[251] = We) : We = t[251];
  let Gt;
  t[252] !== We ? (Gt = /* @__PURE__ */ p(St, { sx: $t, children: /* @__PURE__ */ p(Qn, { elevation: 2, sx: At, children: We }) }), t[252] = We, t[253] = Gt) : Gt = t[253];
  let rn;
  return t[254] !== Gt || t[255] !== j ? (rn = /* @__PURE__ */ O("div", { style: U.mainContainer, children: [
    j,
    Gt
  ] }), t[254] = Gt, t[255] = j, t[256] = rn) : rn = t[256], rn;
};
function gc(e) {
  return !e;
}
function _c(e) {
  return !e;
}
const Pc = Bi(Hr.planIcon), xc = ({
  overlays: e,
  overlayTransformsRef: t,
  handleRotationChange: n,
  handleDragEnd: i,
  handleResize: r,
  resetCounter: o,
  enableEditingOverlay: a,
  activeOverlayId: s,
  overlayOpacity: l
}) => {
  const {
    mapRef: u
  } = Lr(), f = Ye(() => ({
    ...t.current
  }), [t]), _ = Ye(() => e.map((m) => {
    const P = f[m.id], b = m.plan?.calibrationPoints.floorPlan?.imageData, w = m.plan?.calibrationPoints.rfPlan?.imageData, g = m.plan?.calibrationPoints.sinrPlan?.imageData, y = m.plan?.calibrationPoints.dominantCellPlan?.imageData, k = m.selectedCustomPlanName, L = k ? m.plan?.calibrationPoints.customPlan?.find(($) => $.planName === k)?.imagesInfo?.imageData : void 0, C = a && m.id === s;
    let S = 0, V = 0, q = 0, F = 0, Z = 0;
    return C ? m.currentViewMode === "FLOOR_PLAN" ? (S = l, V = 0) : m.currentViewMode === "RF_PLAN" ? (S = 0, V = l) : m.currentViewMode === "SINR_PLAN" ? q = l : m.currentViewMode === "DOMINANT_CELL_PLAN" ? F = l : m.currentViewMode === "CUSTOM_PLAN" && (Z = l) : m.currentViewMode === "FLOOR_PLAN" ? S = l : m.currentViewMode === "RF_PLAN" ? V = l : m.currentViewMode === "SINR_PLAN" ? q = l : m.currentViewMode === "DOMINANT_CELL_PLAN" ? F = l : m.currentViewMode === "CUSTOM_PLAN" && (Z = l), /* @__PURE__ */ p(Nr, { id: m.id, rotation: P?.rotation || 0, setRotation: ($) => n($), map: u || null, floorPlanUrl: b, rfPlanUrl: w, sinrPlanUrl: g, dominantCellPlanUrl: y, customPlanUrl: L, floorPlanOpacity: S, rfPlanOpacity: V, sinrPlanOpacity: q, dominantCellPlanOpacity: F, customPlanOpacity: Z, skewX: P?.skewX || 0, skewY: P?.skewY || 0, onPositionChange: ($, X) => i(m.id, {
      lat: $,
      lng: X
    }), onBoundsChange: ($) => r(m.id, $), resetCounter: o, isActive: C, inactiveOpacity: l, bounds: P?.bounds || Tn(m.position, m) }, m.id);
  }), [e, f, u, n, i, r, o, a, s, l]);
  return /* @__PURE__ */ p(sn, { children: _ });
}, wc = ({
  apiKey: e,
  center: t,
  zoom: n = 16,
  defaultOverlays: i = [],
  defaultOverlayPlan: r,
  enableEditingOverlay: o = !1,
  showMiniControls: a = !1,
  defaultMapType: s = "ROADMAP",
  onOverlaysUpdate: l,
  onTransformsUpdate: u,
  // childrenComponent,
  markers: f,
  onMarkerClick: _,
  onMarkerHover: m,
  onMarkerHoverLeave: P,
  selectedMarkerId: b,
  markerDraggable: w = !1,
  enableCluster: g = !1,
  getMapData: y,
  getMarkerData: k,
  defaultMapPins: L = [],
  onMapPinsUpdate: C,
  showAddressInput: S = !1,
  hideTooltip: V = !0,
  showMetaDataTooltip: q = !1,
  showCurrentLocation: F = !1,
  setMapType: Z,
  floorPlanIcon: $,
  rfPlanIcon: X,
  mapOptions: K,
  miniControlsMainStyles: Q,
  showFullscreenToggleOnMiniControls: T = !0,
  circles: H = [],
  showCircles: et = !1,
  showResetControl: ht = !1,
  // innerMapStyles,
  setShowCircles: ot,
  showCirclesControl: Pt = !1,
  overrideDrag: Ue = !1,
  defaultUpdatedOverlayImages: ge = null
}) => {
  const G = ue({}), ft = ue(!1), zt = ue(null), _e = ue(!1), Jt = ue(y);
  Jt.current = y;
  const Pe = ue(t), xe = ue(!1), [nt, we] = _t(ge), ct = xt((c) => {
    we((d) => d ? d.includes(c) ? d : [...d, c] : [c]);
  }, []), yt = Ye(() => qn((c) => {
    u && u(c);
  }, uo), [u]), [I, tt] = _t(() => i.map((c) => {
    let d;
    c.plan?.calibrationPoints.map?.center ? d = {
      lat: c.plan.calibrationPoints.map.center.latitude,
      lng: c.plan.calibrationPoints.map.center.longitude
    } : d = {
      lat: parseFloat(t?.lat?.toString() || "42.357884"),
      lng: parseFloat(t?.lng?.toString() || "-71.095962")
    };
    const h = {
      floor: !!c.plan?.calibrationPoints.floorPlan?.imageData,
      rf: !!c.plan?.calibrationPoints.rfPlan?.imageData,
      sinr: !!c.plan?.calibrationPoints.sinrPlan?.imageData,
      dom: !!c.plan?.calibrationPoints.dominantCellPlan?.imageData,
      custom: (c.plan?.calibrationPoints.customPlan || []).length > 0
    };
    let x = "RF_PLAN", v;
    if (r) {
      const E = r.trim();
      if (E === "FLOOR_PLAN" && h.floor) x = "FLOOR_PLAN";
      else if (E === "RF_PLAN" && h.rf) x = "RF_PLAN";
      else if (E === "SINR_PLAN" && h.sinr) x = "SINR_PLAN";
      else if (E === "DOMINANT_CELL_PLAN" && h.dom) x = "DOMINANT_CELL_PLAN";
      else if (E.startsWith("CUSTOM_PLAN:") && h.custom) {
        const Y = E.split(":")[1], B = c.plan?.calibrationPoints.customPlan?.find((J) => J.imagesInfo?.imageId === Y);
        B && (x = "CUSTOM_PLAN", v = B.planName);
      }
    }
    r || (h.rf ? x = "RF_PLAN" : h.floor ? x = "FLOOR_PLAN" : h.sinr ? x = "SINR_PLAN" : h.dom ? x = "DOMINANT_CELL_PLAN" : h.custom && (x = "CUSTOM_PLAN", v = c.plan?.calibrationPoints.customPlan?.[0]?.planName));
    const A = {
      points: [],
      heading: 0,
      center: {
        latitude: d.lat,
        longitude: d.lng
      }
    }, N = structuredClone(c);
    if (N.plan ? N.plan.calibrationPoints ? N.plan.calibrationPoints.map || (N.plan.calibrationPoints.map = A) : N.plan.calibrationPoints = {
      map: A
    } : N.plan = {
      calibrationPoints: {
        map: A
      }
    }, N.plan.calibrationPoints.map.points.length === 0) {
      const Y = d.lat, B = d.lng, J = {
        latitude: Y + 5e-4,
        longitude: B + 5e-4,
        id: "floorplan_northeast"
      }, lt = {
        latitude: Y - 5e-4,
        longitude: B - 5e-4,
        id: "floorplan_southwest"
      };
      N.plan.calibrationPoints.map.points = [J, lt];
    }
    return {
      ...N,
      position: d,
      currentViewMode: x,
      ...v ? {
        selectedCustomPlanName: v
      } : {}
    };
  })), [pt, dt] = _t(() => {
    if (!o) return null;
    const c = i.find((h) => h.plan?.calibrationPoints.floorPlan?.imageData);
    return (i.find((h) => h.plan?.calibrationPoints.rfPlan?.imageData) || c)?.id || null;
  }), Zt = qn((c) => {
    C?.(c);
  }, fo), [Qt, Je] = _t(() => L.map((c) => ({
    ...c,
    location: {
      lat: 0,
      lng: 0
    }
    // Initial placeholder, will be calculated when overlay is ready
  }))), [ye, Nt] = _t(0), [It, jt] = _t(!1), Ne = ue(null), [be, ve] = _t(!1), [te, ee] = _t(null), [Ce, Tt] = _t(!1), [at, Bt] = _t(null), [ne, Wt] = _t([]), ie = i[0]?.plan?.calibrationPoints?.map?.opacity, Ht = ie !== void 0 ? ie : po, [Ot, re] = _t(Ht), [Dt, Ve] = _t(!1), {
    isLoaded: bt,
    loadError: Yt
  } = wr({
    id: vr,
    googleMapsApiKey: e,
    libraries: br
  }), [vt, oe] = _t(() => {
    const c = i[0];
    if (c?.plan?.calibrationPoints?.map?.center) {
      const d = c.plan.calibrationPoints.map.center;
      return {
        lat: d.latitude,
        lng: d.longitude,
        name: d.name
      };
    }
    return t;
  }), [ae, Rt] = _t(!1), Ft = ue(!1), D = Lo(I, Pc, $, X);
  $e(() => {
    xe.current = !0, t && !vt && oe(t);
  }, []), $e(() => {
    L.length > 0 && Je(L);
  }, [L]), $e(() => {
    xe.current && t && !ft.current && !ae && (!vt || Math.abs(vt.lat - t.lat) > 1e-5 || Math.abs(vt.lng - t.lng) > 1e-5) && oe(t);
  }, [t, ae, vt]), $e(() => {
    if (!(!bt || !I.length)) {
      if (I.forEach((c) => {
        if (!G.current[c.id]) {
          const d = c.plan?.calibrationPoints?.map?.heading || 0, h = hn(c.position, Math.round(d));
          h.bounds = Tn(c.position, c), G.current[c.id] = h;
        }
      }), !pt && o) {
        const c = I[0];
        if (c && (dt(c.id), !G.current[c.id])) {
          const d = c.plan?.calibrationPoints?.map?.heading || 0, h = hn(c.position, Math.round(d));
          h.bounds = Tn(c.position, c), G.current[c.id] = h;
        }
      }
      yt({
        ...G.current
      }), Nt((c) => c + 1);
    }
  }, [bt, I, pt, o, yt]);
  const [gt, ze] = _t(s), Ae = Ye(() => bt ? {
    controlSize: mo,
    mapTypeControl: !o,
    mapTypeControlOptions: {
      position: google.maps.ControlPosition.TOP_LEFT,
      style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
      mapTypeIds: [google.maps.MapTypeId.ROADMAP, google.maps.MapTypeId.SATELLITE, google.maps.MapTypeId.HYBRID]
    },
    mapTypeId: gt.toLowerCase(),
    mapId: Cr,
    zoomControl: !0,
    zoomControlOptions: {
      position: google.maps.ControlPosition.RIGHT_CENTER
    },
    streetViewControl: !1,
    fullscreenControl: !1,
    scaleControl: !1,
    rotateControl: !1,
    tilt: 0,
    gestureHandling: "greedy",
    disableDefaultUI: !1
  } : {}, [bt, gt, o]), ut = xt((c) => c.map((d) => {
    const h = G.current[d.id];
    if (!h) return null;
    const x = h.bounds;
    if (!x) return null;
    const v = {
      latitude: x.getNorthEast().lat(),
      longitude: x.getNorthEast().lng(),
      id: "floorplan_northeast"
    }, A = {
      latitude: x.getSouthWest().lat(),
      longitude: x.getSouthWest().lng(),
      id: "floorplan_southwest"
    }, N = d.plan?.calibrationPoints.map?.center, E = {
      points: [v, A],
      zoom: d.plan?.calibrationPoints.map?.zoom,
      center: N,
      heading: h.rotation,
      view: gt,
      opacity: Ot
    };
    return {
      id: d.id,
      plan: {
        calibrationPoints: {
          floorPlan: d.plan?.calibrationPoints.floorPlan,
          rfPlan: d.plan?.calibrationPoints.rfPlan,
          sinrPlan: d.plan?.calibrationPoints.sinrPlan,
          dominantCellPlan: d.plan?.calibrationPoints.dominantCellPlan,
          customPlan: d.plan?.calibrationPoints.customPlan,
          map: E
        }
      }
    };
  }).filter((d) => d !== null), [gt, Ot]), it = Ye(() => {
    let c = null, d = null;
    return async (h, x, v) => {
      c && clearTimeout(c);
      const A = new Promise((N) => {
        c = setTimeout(async () => {
          try {
            l?.(h, v);
          } catch (E) {
            console.error("Error in notifyOverlaysUpdate:", E);
          } finally {
            N();
          }
        }, 1e3);
      });
      d = A, await A, A === d && (c = null, d = null);
    };
  }, [l]), le = xt((c) => {
    _e.current || (_e.current = !0, o && (c.center && (ae || (ft.current = !0, zt.current && clearTimeout(zt.current), zt.current = setTimeout(() => {
      setTimeout(() => {
        ft.current = !1;
      }, 3e3);
    }, 300))), tt((d) => {
      const h = d.map((x) => {
        if (x.plan?.calibrationPoints?.map) {
          const v = {
            ...x
          };
          return v.plan && (v.plan = {
            ...v.plan,
            calibrationPoints: {
              ...v.plan.calibrationPoints,
              map: {
                ...v.plan.calibrationPoints.map,
                center: {
                  latitude: c.center.lat,
                  longitude: c.center.lng,
                  name: c?.address
                },
                view: gt,
                // Conditionally update zoom if available
                ...c.zoom ? {
                  zoom: c.zoom
                } : {}
              }
            }
          }), v;
        }
        return x;
      });
      return it(ut(h), "mapData", nt), h;
    })), Jt.current?.(c), setTimeout(() => {
      _e.current = !1;
    }, 100));
  }, [ae, o, gt, ut, it, nt]);
  $e(() => {
    if (f) {
      Wt(f);
      return;
    }
    if (!I?.length || !L?.length || !bt || !google.maps.geometry)
      return;
    const c = I[0];
    let d = G.current[c.id];
    if (!d || !d.bounds) {
      const x = c.plan?.calibrationPoints?.map?.heading || 0;
      if (d = hn(c.position, Math.round(x)), d.bounds = Tn(c.position, c), !d.bounds) {
        console.error("Failed to create initial bounds for marker conversion.");
        return;
      }
      G.current[c.id] = d;
    }
    const h = L.map((x) => {
      const v = Pi(
        x.floorPlan.xOffset,
        // Input is 0-1000
        x.floorPlan.yOffset,
        // Input is 0-1000
        d.bounds,
        d.rotation
      );
      return v ? {
        ...x,
        id: x.id,
        location: v,
        title: x.title,
        metadata: {
          ...x.metadata || {},
          xOffset: x.floorPlan.xOffset,
          yOffset: x.floorPlan.yOffset,
          editable: x.editable ?? !0
        }
      } : null;
    }).filter((x) => x !== null);
    Wt(h);
  }, [I, L, f, bt]);
  const Le = xt((c) => {
    if (!I?.length || f) return;
    const d = I[0], h = G.current[d.id];
    if (!h?.bounds) return;
    const x = h.bounds, v = h.rotation, A = ao(c.location.lat, c.location.lng, h);
    if (!A) return;
    const N = Math.max(0, Math.min(xi, A.xOffset)), E = Math.max(0, Math.min(xi, A.yOffset)), Y = Pi(N, E, x, v);
    if (!Y) return;
    const J = !Array.isArray(c.metadata) && c.metadata?.resetToMapCenter === !0 ? {
      lat: c.location.lat,
      lng: c.location.lng,
      address: c.location.address
    } : Y, lt = L.map((W) => W.id === c.id ? {
      ...W,
      floorPlan: {
        xOffset: N,
        yOffset: E
      },
      location: J
    } : W), R = ne.map((W) => W.id === c.id ? {
      ...W,
      location: J
    } : W);
    Wt(R), Zt(lt), k?.({
      ...c,
      location: J
    });
  }, [I, L, ne, f, k, Zt]), Ie = xt((c) => {
    if (le(c), Ft.current && c.markerLocation && b) {
      const d = {
        id: b,
        location: c.markerLocation
      };
      Le(d);
    }
  }, [le, Ft, b, Le]), Ze = xt((c, d, h) => {
    const x = Qt.find((v) => v.id === c.id);
    x && x.editable !== !1 && (Ft.current = !0), _?.(c, d, h);
  }, [Qt, _]);
  $e(() => {
    const c = () => {
      Ft.current = !1;
    }, d = () => {
      Ft.current = !1;
    };
    return window.addEventListener("mouseup", c), window.addEventListener("mouseleave", d), () => {
      window.removeEventListener("mouseup", c), window.removeEventListener("mouseleave", d);
    };
  }, []), $e(() => {
    const c = i[0]?.plan?.calibrationPoints?.map?.view, d = ut(I);
    gt !== c && d.length > 0 && it(d, "mapTypeChange", nt);
  }, [gt]);
  const se = Ye(() => (c) => {
    if (!c) return null;
    if (!G.current[c]) {
      const d = I.find((h) => h.id === c);
      if (!d) return null;
      G.current[c] = hn(d.position, d.plan?.calibrationPoints?.map?.heading || 0);
    }
    return G.current[c];
  }, [I]), fn = xt((c) => {
    if (!pt) return;
    Rt(!0), ft.current = !0;
    const d = G.current[pt];
    d && (d.rotation = Math.round(c), G.current[pt] = d, yt({
      ...G.current
    }), tt((h) => {
      const x = h.map((v) => {
        if (v.id === pt && v.plan?.calibrationPoints?.map) {
          const A = {
            ...v
          };
          return A.plan && (A.plan = {
            ...A.plan,
            calibrationPoints: {
              ...A.plan.calibrationPoints,
              map: {
                ...A.plan.calibrationPoints.map,
                heading: Math.round(c)
              }
            }
          }), A;
        }
        return v;
      });
      return it(ut(x), "rotationChange", nt), x;
    }), Nt((h) => h + 1), setTimeout(() => {
      Rt(!1), setTimeout(() => {
        ft.current = !1;
      }, 3e3);
    }, 500));
  }, [pt, yt, it, ut, nt]), Oe = xt((c, d) => {
    Rt(!0), ft.current = !0;
    const h = se(c);
    h && (h.position = d, G.current[c] = h, yt({
      ...G.current
    }), tt((x) => {
      const v = x.map((A) => {
        if (A.id === c && A.plan?.calibrationPoints?.map) {
          const N = {
            ...A
          };
          if (N.plan && (N.plan = {
            ...N.plan,
            calibrationPoints: {
              ...N.plan.calibrationPoints,
              map: {
                ...N.plan.calibrationPoints.map,
                // Update center while preserving its structure
                center: {
                  ...N.plan.calibrationPoints.map.center || {},
                  latitude: d.lat,
                  longitude: d.lng
                }
              }
            }
          }, h.bounds)) {
            const E = {
              latitude: h.bounds.getNorthEast().lat(),
              longitude: h.bounds.getNorthEast().lng(),
              id: "floorplan_northeast"
            }, Y = {
              latitude: h.bounds.getSouthWest().lat(),
              longitude: h.bounds.getSouthWest().lng(),
              id: "floorplan_southwest"
            };
            N.plan.calibrationPoints.map.points = [E, Y];
          }
          return N;
        }
        return A;
      });
      return it(ut(v), "dragEnd", nt), v;
    }), Nt((x) => x + 1), setTimeout(() => {
      Rt(!1), setTimeout(() => {
        ft.current = !1;
      }, 3e3);
    }, 500));
  }, [se, yt, it, ut, nt]), Me = xt((c, d) => {
    Rt(!0), ft.current = !0;
    const h = se(c);
    h && (h.bounds = d, G.current[c] = h, yt({
      ...G.current
    }), tt((x) => {
      const v = x.map((A) => {
        if (A.id === c && A.plan?.calibrationPoints?.map) {
          const N = {
            ...A
          };
          if (N.plan) {
            const E = {
              latitude: d.getNorthEast().lat(),
              longitude: d.getNorthEast().lng(),
              id: "floorplan_northeast"
            }, Y = {
              latitude: d.getSouthWest().lat(),
              longitude: d.getSouthWest().lng(),
              id: "floorplan_southwest"
            }, B = d.getCenter(), J = B ? {
              latitude: B.lat(),
              longitude: B.lng(),
              ...N.plan.calibrationPoints.map.center ? {
                name: N.plan.calibrationPoints.map.center.name
              } : {}
            } : void 0;
            N.plan = {
              ...N.plan,
              calibrationPoints: {
                ...N.plan.calibrationPoints,
                map: {
                  ...N.plan.calibrationPoints.map,
                  points: [E, Y],
                  ...J ? {
                    center: J
                  } : {}
                }
              }
            }, B && (h.position = {
              lat: B.lat(),
              lng: B.lng()
            }, G.current[c] = h);
          }
          return N;
        }
        return A;
      });
      return it(ut(v), "resize", nt), v;
    }), Nt((x) => x + 1), setTimeout(() => {
      Rt(!1), setTimeout(() => {
        ft.current = !1;
      }, 3e3);
    }, 500));
  }, [se, yt, it, ut, nt]), Se = (c, d) => {
    c && (dt(c), tt((h) => h.map((x) => x.id === c ? {
      ...x,
      currentViewMode: d
    } : x)), Nt((h) => h + 1));
  }, Et = xt((c, d, h, x) => {
    const v = `overlay-${Date.now()}`, A = vt || t || {
      lat: 0,
      lng: 0,
      address: ""
    }, N = {
      id: v,
      position: A,
      currentViewMode: h,
      plan: {
        calibrationPoints: {
          map: {
            points: [],
            heading: 0,
            center: {
              latitude: A.lat,
              longitude: A.lng,
              name: A.address
            }
          }
        }
      }
    };
    x || h === "FLOOR_PLAN" ? N.plan.calibrationPoints.floorPlan = {
      imageData: c,
      imageName: d
    } : h === "RF_PLAN" ? N.plan.calibrationPoints.rfPlan = {
      imageData: c,
      imageName: d
    } : h === "SINR_PLAN" ? N.plan.calibrationPoints.sinrPlan = {
      imageData: c,
      imageName: d
    } : h === "DOMINANT_CELL_PLAN" ? N.plan.calibrationPoints.dominantCellPlan = {
      imageData: c,
      imageName: d
    } : h === "CUSTOM_PLAN" && (N.plan.calibrationPoints.customPlan = [{
      planName: D.state.customPlanName || "Custom Plan",
      imagesInfo: {
        imageData: c,
        imageName: d
      }
    }], N.selectedCustomPlanName = D.state.customPlanName || "Custom Plan");
    const E = hn(A);
    if (bt) {
      const B = new google.maps.LatLngBounds(new google.maps.LatLng(A.lat - 5e-4, A.lng - 5e-4), new google.maps.LatLng(A.lat + 5e-4, A.lng + 5e-4));
      if (E.bounds = B, N.plan?.calibrationPoints?.map) {
        const J = {
          latitude: B.getNorthEast().lat(),
          longitude: B.getNorthEast().lng(),
          id: "floorplan_northeast"
        }, lt = {
          latitude: B.getSouthWest().lat(),
          longitude: B.getSouthWest().lng(),
          id: "floorplan_southwest"
        };
        N.plan.calibrationPoints.map.points = [J, lt];
      }
    }
    return G.current[v] = E, N;
  }, [vt, t, bt, D.state.customPlanName]), Qe = xt(() => {
    let c = [];
    const d = new Set(nt || []), h = D.state.mode, x = D.state.editingOverlayId, v = D.state.floorPlan, A = D.state.rfPlan, N = D.state.sinrPlan, E = D.state.dominantCellPlan, Y = D.state.customPlan, B = D.state.customPlanName, J = D.state.targetCustomPlanName, lt = D.state.targetCustomPlanIndex;
    if (h === "ADD_FLOOR_PLAN") {
      if (!v.previewUrl) {
        alert("Please upload a floor plan image");
        return;
      }
      if (x)
        tt((R) => {
          const W = R.map((z) => {
            if (z.id === x) {
              const M = z.plan?.calibrationPoints?.map?.center, mt = {
                ...z,
                // Shallow copy top-level properties
                plan: {
                  // Create a new plan object
                  ...z.plan || {},
                  // Copy properties from the old plan, or start with empty if no plan
                  calibrationPoints: {
                    // Create a new calibrationPoints object
                    ...z.plan?.calibrationPoints || {},
                    // Copy properties from old calPoints, or start with empty
                    map: z.plan?.calibrationPoints?.map || {
                      // Ensure map object exists, initialize if not
                      points: [],
                      heading: 0,
                      center: {
                        latitude: z.position.lat,
                        longitude: z.position.lng,
                        name: M?.name
                      }
                    }
                    // rfPlan will be carried over if it existed on overlay.plan.calibrationPoints
                    // floorPlan will be assigned below
                  }
                }
              };
              return mt.plan.calibrationPoints.floorPlan = {
                imageData: v.previewUrl,
                imageName: v.imageName
              }, mt.currentViewMode = "FLOOR_PLAN", mt;
            }
            return z;
          });
          return c = W, W;
        }), dt(x), ct("FLOOR_PLAN"), d.add("FLOOR_PLAN");
      else {
        const R = Et(v.previewUrl, v.imageName, "FLOOR_PLAN", !0);
        tt((W) => (c = [...W, R], c)), dt(R.id), ct("FLOOR_PLAN"), d.add("FLOOR_PLAN");
      }
    } else if (h === "ADD_RF_PLAN") {
      if (!A.previewUrl) {
        alert("Please upload an RF plan image");
        return;
      }
      if (!x && I.length === 0) {
        const R = Et(A.previewUrl, A.imageName, "RF_PLAN", !1);
        tt((W) => (c = [...W, R], c)), dt(R.id), ct("RF_PLAN"), d.add("RF_PLAN");
      } else {
        const R = x || I[0]?.id;
        if (!R) {
          alert("Error: No overlay available for editing");
          return;
        }
        tt((W) => {
          const z = W.map((M) => {
            if (M.id === R) {
              const mt = M.plan?.calibrationPoints?.map?.center, j = {
                ...M,
                // Shallow copy top-level properties
                plan: {
                  // Create a new plan object
                  ...M.plan || {},
                  // Copy properties from the old plan, or start with empty if no plan
                  calibrationPoints: {
                    // Create a new calibrationPoints object
                    ...M.plan?.calibrationPoints || {},
                    // Copy properties from old calPoints, or start with empty
                    map: M.plan?.calibrationPoints?.map || {
                      // Ensure map object exists, initialize if not
                      points: [],
                      heading: 0,
                      center: {
                        latitude: M.position.lat,
                        longitude: M.position.lng,
                        name: mt?.name
                      }
                    }
                    // floorPlan will be carried over if it existed on overlay.plan.calibrationPoints
                    // rfPlan will be assigned below
                  }
                }
              };
              return j.plan.calibrationPoints.rfPlan = {
                imageData: A.previewUrl,
                imageName: A.imageName
              }, j.currentViewMode = "RF_PLAN", j;
            }
            return M;
          });
          return c = z, z;
        }), dt(R), ct("RF_PLAN"), d.add("RF_PLAN");
      }
    } else if (h === "ADD_SINR_PLAN") {
      if (!N.previewUrl) {
        alert("Please upload a SINR plan image");
        return;
      }
      if (!x && I.length === 0) {
        const R = Et(N.previewUrl, N.imageName, "SINR_PLAN", !1);
        tt((W) => (c = [...W, R], c)), dt(R.id);
      } else {
        const R = x || I[0]?.id;
        if (!R) {
          alert("Error: No overlay available for editing");
          return;
        }
        tt((W) => {
          const z = W.map((M) => {
            if (M.id === R) {
              const mt = M.plan?.calibrationPoints?.map?.center, j = {
                ...M,
                plan: {
                  ...M.plan || {},
                  calibrationPoints: {
                    ...M.plan?.calibrationPoints || {},
                    map: M.plan?.calibrationPoints?.map || {
                      points: [],
                      heading: 0,
                      center: {
                        latitude: M.position.lat,
                        longitude: M.position.lng,
                        name: mt?.name
                      }
                    }
                  }
                }
              };
              return j.plan.calibrationPoints.sinrPlan = {
                imageData: N.previewUrl,
                imageName: N.imageName
              }, j.currentViewMode = "SINR_PLAN", j;
            }
            return M;
          });
          return c = z, z;
        }), dt(R);
      }
      ct("SINR_PLAN"), d.add("SINR_PLAN");
    } else if (h === "ADD_DOMINANT_CELL_PLAN") {
      if (!E.previewUrl) {
        alert("Please upload a Dominant Cell plan image");
        return;
      }
      const R = x || I[0]?.id;
      if (!R && I.length === 0) {
        const W = Et(E.previewUrl, E.imageName, "DOMINANT_CELL_PLAN", !1);
        tt((z) => (c = [...z, W], c)), dt(W.id);
      } else R && (tt((W) => {
        const z = W.map((M) => {
          if (M.id === R) {
            const mt = M.plan?.calibrationPoints?.map?.center, j = {
              ...M,
              plan: {
                ...M.plan || {},
                calibrationPoints: {
                  ...M.plan?.calibrationPoints || {},
                  map: M.plan?.calibrationPoints?.map || {
                    points: [],
                    heading: 0,
                    center: {
                      latitude: M.position.lat,
                      longitude: M.position.lng,
                      name: mt?.name
                    }
                  }
                }
              }
            };
            return j.plan.calibrationPoints.dominantCellPlan = {
              imageData: E.previewUrl,
              imageName: E.imageName
            }, j.currentViewMode = "DOMINANT_CELL_PLAN", j;
          }
          return M;
        });
        return c = z, z;
      }), dt(R));
      ct("DOMINANT_CELL_PLAN"), d.add("DOMINANT_CELL_PLAN");
    } else if (h === "ADD_CUSTOM_PLAN") {
      const R = x || I[0]?.id;
      if (!R && I.length === 0) {
        if (!Y.previewUrl) {
          alert("Please upload a Custom plan image");
          return;
        }
        const j = Et(Y.previewUrl, Y.imageName, "CUSTOM_PLAN", !1);
        j.selectedCustomPlanName = B || "Custom Plan", tt(($t) => (c = [...$t, j], c)), dt(j.id);
      } else R && (tt((j) => {
        const $t = j.map((At) => {
          if (At.id === R) {
            const Gt = At.plan?.calibrationPoints?.customPlan || [], rn = B?.trim(), st = lt ?? Gt.findIndex((Ee) => Ee.planName === (J || "")), pn = st >= 0, dn = rn || J || "Custom Plan", Yn = pn ? st : Gt.findIndex((Ee) => Ee.planName === dn), An = [...Gt];
            if (Yn >= 0) {
              const Ee = An[Yn], Xn = {
                imageData: Y.previewUrl || Ee.imagesInfo?.imageData,
                imageName: Y.imageName || Ee.imagesInfo?.imageName,
                imageId: Ee.imagesInfo?.imageId
              };
              An[Yn] = {
                planName: dn,
                imagesInfo: Xn
              };
            } else {
              if (!Y.previewUrl)
                return At;
              const Xn = `new_custom_${dn.replace(/\s+/g, "_")}_${Date.now()}`;
              An.push({
                planName: dn,
                imagesInfo: {
                  imageData: Y.previewUrl,
                  imageName: Y.imageName,
                  imageId: Xn
                }
              });
            }
            const xr = {
              ...At,
              plan: {
                ...At.plan || {},
                calibrationPoints: {
                  ...At.plan?.calibrationPoints || {},
                  customPlan: An
                }
              },
              currentViewMode: "CUSTOM_PLAN",
              selectedCustomPlanName: dn
            }, Gn = G.current[At.id];
            return Gn && Gn.bounds && (G.current[At.id] = {
              ...Gn
            }), xr;
          }
          return At;
        });
        return c = $t, $t;
      }), dt(R));
      const z = c.find((j) => j.id === (x || I[0]?.id))?.plan?.calibrationPoints?.customPlan || [];
      let M;
      typeof lt == "number" && lt >= 0 && z[lt]?.imagesInfo?.imageId ? M = z[lt].imagesInfo.imageId : M = z.find(($t) => $t.planName === (B || J || ""))?.imagesInfo?.imageId;
      const mt = M ? `CUSTOM_PLAN:${M}` : `CUSTOM_PLAN:${B?.trim() || J || "Custom Plan"}`;
      ct(mt), d.add(mt);
    }
    ft.current = !0, setTimeout(() => {
      ft.current = !1;
    }, 5e3), D.actions.closeDialog(), Nt((R) => R + 1), it(ut(c), "createOverlay", Array.from(d)), yt({
      ...G.current
    });
  }, [D.state, D.actions, I, Et, yt, it, ut, ct, nt]), je = (c) => {
    ee(c), ve(!0);
  }, tn = (c) => {
    Bt(c), Tt(!0);
  }, Te = () => {
    if (!te) return;
    const c = I.find((v) => v.id === te), d = c?.plan?.calibrationPoints?.floorPlan, h = c?.plan?.calibrationPoints?.rfPlan, x = new Set(nt || []);
    tt([]), d && (x.add("FLOOR_PLAN"), ct("FLOOR_PLAN")), h && (x.add("RF_PLAN"), ct("RF_PLAN")), it([], "resetConfirm", Array.from(x)), ve(!1), ee(null), Nt((v) => v + 1);
  }, De = xt(() => {
    if (!at) return;
    const c = I.findIndex((J) => J.id === pt);
    if (c === -1 || !I[c]?.plan?.calibrationPoints) {
      Tt(!1), Bt(null);
      return;
    }
    const d = JSON.parse(JSON.stringify(I)), h = d[c], x = new Set(nt || []);
    if (at === "FLOOR_PLAN")
      h.plan.calibrationPoints.floorPlan = void 0, x.add("FLOOR_PLAN"), ct("FLOOR_PLAN");
    else if (at === "RF_PLAN")
      h.plan.calibrationPoints.rfPlan = void 0, x.add("RF_PLAN"), ct("RF_PLAN");
    else if (at === "SINR_PLAN")
      h.plan.calibrationPoints.sinrPlan = void 0, x.add("SINR_PLAN"), ct("SINR_PLAN");
    else if (at === "DOMINANT_CELL_PLAN")
      h.plan.calibrationPoints.dominantCellPlan = void 0, x.add("DOMINANT_CELL_PLAN"), ct("DOMINANT_CELL_PLAN");
    else if (at === "CUSTOM_PLAN") {
      const J = d[c].selectedCustomPlanName;
      if (J) {
        const lt = h.plan.calibrationPoints.customPlan || [], R = lt.find((M) => M.planName === J);
        h.plan.calibrationPoints.customPlan = lt.filter((M) => M.planName !== J);
        const W = R?.imagesInfo?.imageId, z = W ? `CUSTOM_PLAN:${W}` : `CUSTOM_PLAN:${J}`;
        x.add(z), ct(z);
      }
    }
    const v = h.plan.calibrationPoints.floorPlan !== void 0, A = h.plan.calibrationPoints.rfPlan !== void 0, N = h.plan.calibrationPoints.sinrPlan !== void 0, E = h.plan.calibrationPoints.dominantCellPlan !== void 0, Y = (h.plan.calibrationPoints.customPlan || []).length > 0;
    let B = d;
    !v && !A && !N && !E && !Y ? B = [] : ((at === "FLOOR_PLAN" && h.currentViewMode === "FLOOR_PLAN" || at === "RF_PLAN" && h.currentViewMode === "RF_PLAN" || at === "SINR_PLAN" && h.currentViewMode === "SINR_PLAN" || at === "DOMINANT_CELL_PLAN" && h.currentViewMode === "DOMINANT_CELL_PLAN" || at === "CUSTOM_PLAN" && h.currentViewMode === "CUSTOM_PLAN") && (v ? h.currentViewMode = "FLOOR_PLAN" : A ? h.currentViewMode = "RF_PLAN" : N ? h.currentViewMode = "SINR_PLAN" : E ? h.currentViewMode = "DOMINANT_CELL_PLAN" : Y && (h.currentViewMode = "CUSTOM_PLAN", h.selectedCustomPlanName = h.plan.calibrationPoints.customPlan?.[0]?.planName)), B = d), tt(B), it(B, "deletePlanConfirm", Array.from(x)), Tt(!1), Bt(null);
  }, [at, I, pt, it, ct, nt]), Be = xt((c) => {
    jt((d) => !d), c.currentTarget.blur();
  }, []);
  $e(() => {
    const c = (d) => {
      d.key === "Escape" && It && jt(!1);
    };
    return document.addEventListener("keydown", c), () => {
      document.removeEventListener("keydown", c);
    };
  }, [It]);
  const en = qn((c) => {
    const d = c?.toUpperCase();
    !d || d === gt || ze(d);
  }, ho), Re = xt((c, d) => {
    const h = d === "FLOOR_PLAN" ? "ADD_FLOOR_PLAN" : d === "RF_PLAN" ? "ADD_RF_PLAN" : d === "SINR_PLAN" ? "ADD_SINR_PLAN" : d === "DOMINANT_CELL_PLAN" ? "ADD_DOMINANT_CELL_PLAN" : "ADD_CUSTOM_PLAN";
    if (d === "CUSTOM_PLAN" && c) {
      const x = I.find((E) => E.id === c), v = x?.selectedCustomPlanName || null, A = x?.plan?.calibrationPoints?.customPlan || [], N = v ? A.findIndex((E) => E.planName === v) : -1;
      N >= 0 ? D.actions.openDialog(h, c, {
        targetName: v,
        targetIndex: N,
        targetImageId: A[N]?.imagesInfo?.imageId || null
      }) : D.actions.openDialog(h, c);
    } else
      D.actions.openDialog(h, c);
  }, [I, D.actions]), Fe = xt(() => {
    D.actions.openDialog("ADD_CUSTOM_PLAN", I[0]?.id || null);
  }, [I, D.actions]), Mt = xt((c) => {
    const d = Number(Number(c.toFixed(2)));
    if (!isNaN(d)) {
      re(d);
      const h = ut(I);
      it(h, "opacityChange", nt);
    }
  }, [re, ut, I, it, nt]), ce = (c) => {
    I.length > 0 && (Dt && (Mt(Ht), Ve(!1)), Se(I[0].id, c));
  }, nn = () => {
    Mt(Dt ? Ht : 0), Ve(!Dt);
  };
  return Yt ? (console.log(Yt), /* @__PURE__ */ O("div", { children: [
    "There was an error loading the Google Maps API",
    /* @__PURE__ */ p("p", { children: Yt.message })
  ] })) : /* @__PURE__ */ O(sn, { children: [
    /* @__PURE__ */ p(ro, { open: be, onClose: () => ve(!1), onConfirm: Te }),
    /* @__PURE__ */ p(oo, { open: Ce, onClose: () => Tt(!1), onConfirm: De, planToDelete: at || void 0, customPlanName: at === "CUSTOM_PLAN" ? I.find((c) => c.id === pt)?.selectedCustomPlanName : void 0 }),
    /* @__PURE__ */ p(mc, { open: D.state.isOpen, onClose: D.actions.closeDialog, planInfo: D.planInfo, customPlanName: D.state.customPlanName, onCustomPlanNameChange: D.actions.setCustomPlanName, onCustomPlanNameBlur: D.actions.markCustomPlanNameTouched, onFileSelect: (c) => {
      const d = D.state.mode, h = d === "ADD_FLOOR_PLAN" ? D.handlers.floorPlan : d === "ADD_RF_PLAN" ? D.handlers.rfPlan : d === "ADD_SINR_PLAN" ? D.handlers.sinrPlan : d === "ADD_DOMINANT_CELL_PLAN" ? D.handlers.dominantCellPlan : D.handlers.customPlan;
      Yr(h)(c);
    }, onSubmit: Qe }),
    /* @__PURE__ */ O("div", { ref: Ne, style: It ? gi.fullscreen : gi.normal, children: [
      !o && a && /* @__PURE__ */ p(lo, { currentViewMode: I[0]?.currentViewMode || "FLOOR_PLAN", isOverlayHidden: Dt, overlayOpacity: Ot, hasFloorPlan: !!I[0]?.plan?.calibrationPoints?.floorPlan?.imageData, hasRFPlan: !!I[0]?.plan?.calibrationPoints?.rfPlan?.imageData, onViewModeChange: ce, onOverlayVisibilityToggle: nn, onOpacityChange: Mt, miniControlsMainStyles: Q, onFullscreenToggle: Be, isFullscreen: It, showFullscreenToggle: T, showCirclesControl: Pt, setShowCircles: ot, showCircles: et, hasOverlays: I.length > 0 }),
      o && /* @__PURE__ */ p(hc, { overlays: I, activeOverlayId: pt, overlayOpacity: Ot, isFullscreen: It, onResetOverlay: je, onOpacityChange: Mt, onFullscreenToggle: Be, onViewModeChange: ce, onUpload: (c) => Re(I[0]?.id || null, c), onPlanDelete: tn, onSelectCustomPlan: (c) => {
        tt((d) => d.map((h) => h.id === I[0]?.id ? {
          ...h,
          selectedCustomPlanName: c,
          currentViewMode: "CUSTOM_PLAN"
        } : h)), Nt((d) => d + 1);
      }, onAddCustomPlan: Fe, onMapTypeChange: (c) => {
        ze(c), Z?.(c);
      }, currentMapType: gt }),
      /* @__PURE__ */ p(
        Ar,
        {
          apiKey: e,
          center: xe.current ? vt : Pe.current,
          zoom: n,
          mapType: gt.toUpperCase(),
          markers: ne,
          options: {
            ...Ae,
            ...K,
            gestureHandling: Ft.current ? "none" : "auto"
            // Prevent map movement during drag
          },
          width: "100%",
          height: "100%",
          onMarkerClick: Ze,
          onMarkerHover: m,
          onMarkerHoverLeave: P,
          selectedID: b?.toString(),
          hideTooltip: V,
          showMetaDataTooltip: q,
          setMapType: (c) => {
            en(c), Z && Z(c);
          },
          markerDraggable: w,
          enableCluster: g,
          showAddressInput: S,
          showCurrentLocation: F,
          circles: et ? H : [],
          showCircles: et,
          showResetControl: ht,
          getMapData: Ie,
          doNotGenerateAddress: !o && (!ne.length || !w),
          overrideDrag: Ue,
          getMarkerData: f ? k : Le,
          children: /* @__PURE__ */ p(xc, { overlays: I, overlayTransformsRef: G, handleRotationChange: fn, handleDragEnd: Oe, handleResize: Me, resetCounter: ye, enableEditingOverlay: o, activeOverlayId: pt, overlayOpacity: Ot })
        },
        `${r ?? "none"}-${i[0]?.id ?? "none"}`
      )
    ] })
  ] });
}, Qp = yr(wc);
export {
  hc as C,
  Zp as E,
  Eo as I,
  Qp as M,
  wc as O,
  Ut as S,
  hr as T,
  mc as U,
  Jp as W,
  Ko as a,
  qo as b,
  Ho as c,
  zo as d,
  Hi as e,
  an as f,
  ls as g,
  Kp as i,
  Ml as r
};
